import React from 'react';
import { Helmet } from 'react-helmet';
import { Link as RouterLink } from "react-router-dom";
import { createBrowserHistory } from 'history';
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import ApiOneDrive from "../../../assets/js/utils/oneDrive/Api.js";
import ApiSharepoint from "../../../assets/js/utils/Sharepoint/Api.js";
import ApiGoogleDrive from "../../../assets/js/utils/GoogleDrive/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import Cookie from "../../../assets/js/utils/Cookie.js";
import { helper } from "../../../assets/js/utils/Element.js";
import PropTypes from "prop-types";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import ReactTable from "react-table";
import LoaderComponent from "../../components/Loader.js";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteFileModal from "../../components/User/DeleteFileModal.jsx";
import ProcessingModal from "../../components/User/ProcessingModal.js";
import NewFolderModal from "../../components/User/NewFolderModal.js";
import CopyFilesModal from "../../components/User/CopyFilesModal.js";
import MoveFilesModal from "../../components/User/MoveFilesModal.js";
import RenameFileModal from "../../components/User/RenameFileModal.js";
import ShareModal from "../../components/User/ShareModal.js";
import NewLinkModal from "../../components/User/NewLinkModal.js";
import SearchInput from "../../components/User/SearchInput.js";
import FileVersionModal from "../../components/User/FileVersionModal.jsx";
import NewFileModal from "../../components/User/NewFileModal.js";
import ImagePreviewModal from "../../components/User/imageModal.js";
import EditIcon from '@material-ui/icons/Edit';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import ChevronRight from "@material-ui/icons/ChevronRight";
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu } from "react-contextmenu";
import DragNDrop from "../../components/Drag/Drop.jsx";
import OfficeFileModal from "../../components/User/OfficeFileModal.jsx";
// import PdfFileModal from "../../components/User/PdfFileModal.jsx";
import PdfViewModal from "../../components/User/PdfViewModal.jsx";
import NoPreviewModal from "../../components/User/NoPreviewModal.js";
import Menu from '@material-ui/core/Menu';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import ConfirmationModal from "../../components/User/ConfirmationModal.js";
import DetailsSection from "../../components/User/DetailsSection.js";
import withStyles from "@material-ui/core/styles/withStyles";
import Config from '../../../../Config.js';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SignModal from "../../components/Docusign/SignModal.jsx";
import AdobeSignModal from "../../components/Adobesign/SignModal.jsx";
import NewEditAccountModal from '../../components/User/oneDrive/NewEditAccountModal.js';
import SharepointAccountModal from "../../components/User/Sharepoint/SharepointAccountModal.jsx";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Carousel from "react-slick";
import GoogleDrivePicker from "../../components/User/GoogleDrivePicker.jsx";

import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";

const history = createBrowserHistory();

const UserHome = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;
        let path = helper.getParam("dir");
        if(path === null || path === "null"){
            path = "/";
        }
        const backPath = this.getBackPath(path);
        this.editDocRef = React.createRef();
        this.editDocTokenRef = React.createRef();
        this.editDocSecretRef = React.createRef();
        
        let files = [];
        let sharedWithUsers = [];
        let shareFileId = '';
        let resetComponent = false;
        let uploadFileModal = false;

        this.state = {
            limit: 200,
            totalItemCount: 0,
            response: null,
            recentFiles: null,
            cancelToken: null,
            recentFilesCancelToken: null,
            page: 1,
            loading: false,
            loadingMore: false,
            totalPages: 1,
            checked: [],
            path: decodeURIComponent(path.trim()),
            backPath: backPath,
            deleteFileModal: false,
            deleteSnackbarOpen: false,
            uploadFileModal: uploadFileModal,
            favourites: [],
            shareFileModal: false,
            sharingFiles: false,
            downloadModal: false,
            downloadingFiles: false,
            downloadUrl: "",
            downloadFile: false,
            file: null,
            newFolderModal: false,
            creatingFolder: false,
            copyMyDocModal: false,
            copyingMyDocsFilesModal: false,
            copyFilesModal: false,
            copyingFilesModal: false,
            copyingFilesError: null,
            moveFilesModal: false,
            movingFilesModal: false,
            renameFileModal: false,
            renamingFileModal: false,
            firstTimeLoginModal: false,
            files: files,
            errorMessage: null,
            advShareModal: false,
            sharedWith: null,
            currentFile: null,
            downloadLink: null,
            linkName: false,
            searchFormData: this.defaultSearchFormData(),
            newUser: null,
            shareFileId: shareFileId,
            fileCopyStatus: '',
            sharedWithUsers: sharedWithUsers,
            checkedAll: false,
            versionsModal: false,
            newLinkUploaded: false,
            officeFileModal: false,
            officeFileAction: "view",
            docMenuEl: null,
            uploadMenuEl: null,
            newFileModal: false,
            newFileExtension: null,
            creatingFile: false,
            newFileError: false,
            newFileErrorMessage: null,
            imagePreviewModal: false,
            layoutType: 'list',
            pdfFileModal: false,
            detailsSection: false,
            saving: false,
            linkHash: null,
            activeTab: 0,
            oneDriveEmail :null,
            isOneDriveFolder :false,
            newDataPush:[],
            processedFileIds:[],
            folderParentIdOneDrive:null,
            folderParentPathOneDrive:null,
            newFolderModalOneDrive:false,
            docusignModal: false,
            adobesignModal: false,
            filesCopiedSize: 0,
            canceledCopyingMyDocsFilesModal: false,
            resetComponent: resetComponent,
            newEditAccountModal: false,
            editAccountType: '',
            sharepointAccountModal: false,
            upgradeModal: false,
            loadingRecentFiles: false,
            deleteFilesCount: 0,
            createSnackbarOpen: false,
            createSnackbarType: null,
            createSnackbarName: null,
            createSnackbarPath: null,
            fileActionsMenuEl: null,
            recentFilesOpen: true,
            uploadType: 'file',
            transferActiveTab: 0,
            breadcrumbData: [],
        };

        this.loadingFolder = false;
        this.onShareModal = this.onShareModal.bind(this);
        this.onShareModalSuccess = this.onShareModalSuccess.bind(this);
        this.onAdvShareModal = this.onAdvShareModal.bind(this);
        this.closeDeleteSnackbar = this.closeDeleteSnackbar.bind(this);
        this.closeCreateSnackbar = this.closeCreateSnackbar.bind(this);
    }
    componentDidMount(){
        const { path } = this.state;
        const { authorized, user, copyFilesState, createLinkState } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+decodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
            return;
        }
        if(authorized){
            if(user.login === 0){
                localStorage.setItem("show_first_view_shared", (user.login === 0));
            }
            if(user.agreement_login === 0){
                this.history.push("/agreement/policy");
                return;
            }
            if(user.level_id === 5){
                this.history.push("/user/shared");
                return;
            }

            if(window.location.pathname === "/user/home/connect/docusign"){
                this.onDocusignConnectCallback();
                return;
            }else if(window.location.pathname === "/user/home/connect/adobesign"){
                this.onAdobesignConnectCallback();
                return;
            }else{
                let oldState = localStorage.getItem("sendlinx_home_state");
                if(oldState !== null){
                    oldState = JSON.parse(oldState);
                    this.setState(oldState);
                    return;
                }
            }
            if(!this.state.resetComponent){
                const location = this.history.location;
                let searchFormData = null;
                if(location.state){
                    searchFormData = location.state;
                }
                if(searchFormData !== null){
                    this.onSearchInputSuccess(searchFormData.searchFormData);
                }else if(copyFilesState === null){
                    this.loadFiles();
                    if(path.indexOf("/My Docs") !== -1){
                        this.getRecentFiles();
                    }
                    if(createLinkState !== null){
                        this.setState({
                            checked: createLinkState.fileIds,
                            path: createLinkState.path,
                        },() => {
                            this.onShareModal(true);
                        });
                    }
                }
            }
        }
    }
    componentWillUnmount(){
        if (this.state.cancelToken) {
            this.state.cancelToken.cancel('Request Cancelled')
        }
        if (this.state.recentFilesCancelToken) {
            this.state.recentFilesCancelToken.cancel('Request Cancelled')
        }
    }
    defaultSearchFormData(){
        return {
            search: '',
            fileName: '',
            searchIn: '',
            attachmentContains: '',
            from: '',
            to: '',
            subject: '',
            destination: '',
            startDate: '',
            endDate: '',
            expiryStartDate: '',
            expiryEndDate: '',
        }
    }
    clearSearch(){
        this.setState({
            searchFormData: this.defaultSearchFormData()
        }, () => {
            this.loadFiles()
        });
    }
    onSearchInputSuccess(searchData){
        const location = this.history.location;
        const pathname = location.pathname;

        if(pathname === '/user/home' && searchData.searchIn === 'link-manager'){
            this.history.push({
                pathname: '/user/links',
                search: '',
                state: { searchFormData: searchData }
            });
            return;
        }

        let backPath = '';
        if(searchData.searchIn === 'web'){
            backPath = '/Email/Web';
        }else if(searchData.searchIn === 'docs'){
            backPath = '/My Docs';
        }else if(searchData.searchIn === 'email'){
            backPath = '/';
        }

        this.setState({
            searchFormData: {
                search: searchData.search,
                fileName: searchData.fileName,
                searchIn: searchData.searchIn,
                attachmentContains: searchData.attachmentContains,
                from: searchData.from,
                to: searchData.to,
                subject: searchData.subject,
                destination: searchData.destination,
                startDate: searchData.startDate,
                endDate: searchData.endDate,
                expiryStartDate:  searchData.expiryStartDate,
                expiryEndDate:  searchData.expiryEndDate,
            }
        }, () => {
            this.loadFiles(false, null, backPath);
        });
    }
    getRecentFiles(){
        const source = axios.CancelToken.source();
        
        this.setState({
            recentFilesCancelToken: source,
            loadingRecentFiles: true
        })

        let requestData = {
            recentFiles: true,
            page: 1,
            limit: 9,
            path: '/My Docs',
            includeSub: true
        };

        Api.getFiles(requestData, source).then(data => {
            const response = data.response;
            
            this.setState({
                recentFiles: response,
                loadingRecentFiles: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    loginWith(sharepointAuth = false){
        let clientId = Config.getClientIdOneDrive();
        let redirectUrlOneDrive = Config.getRedirectUrlOneDrive();
        const scope = Config.getOnedriveScope();
        
        if(sharepointAuth){
            clientId = Config.getClientIdSharepoint();
            localStorage.setItem("sharepoint_auth_flow", 1);
            localStorage.removeItem("one_drive_auth_flow");
        }else{
            localStorage.setItem("one_drive_auth_flow", 1);
            localStorage.removeItem("sharepoint_auth_flow");
        }
        localStorage.removeItem("google_drive_auth_flow");

        const URL ='https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id='+clientId+'&scope='+scope+'&response_type=token&redirect_uri='+redirectUrlOneDrive+'&prompt=select_account';
        window.location.replace(URL);
    }
    loginWithGoogle(){
        localStorage.removeItem("one_drive_auth_flow");
        localStorage.removeItem("sharepoint_auth_flow");
        localStorage.setItem("google_drive_auth_flow", 1);

        const clientId = Config.getGoogleDriveClientId();
        const redirectUrl = Config.getGoogleDriveRedirectUrl();
        const scope = Config.getGoogleDriveScope();
        const responseType = 'token';
        const prompt = 'select_account';

        const URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=${responseType}&scope=${scope}&prompt=${prompt}`;

        window.location.replace(URL);
    }
    loadFiles(viewMore = false, newPath = null, backPath = ""){
        const { user } = this.store.getState();
        let { page, path, favourites, searchFormData, shareFileId } = this.state;
        
        const source = axios.CancelToken.source();
        if(backPath === '/'){
            return true;
        }
        if(viewMore){
            page += 1;
        }else{
            page = 1;
        }
        let requestData = {
            page: page,
            limit: 200
        };

        if(path === "/" && newPath !== null){
            path = "";
        }
        requestData['path'] = path;
        if(newPath !== null){
            path += "/"+newPath;
            requestData['path'] = path;
        }
        if(backPath !== ""){
            requestData['path'] = path = backPath;
        }

        // search for request data
        if(searchFormData.search || searchFormData.fileName){
            requestData['name'] = searchFormData.fileName ? searchFormData.fileName : searchFormData.search;
        }
        if(searchFormData.startDate){
            requestData['startDate'] = searchFormData.startDate;
        }
        if(searchFormData.endDate){
            requestData['endDate'] = searchFormData.endDate;
        }

        let fileIdParam = "";
        let fileId = '';
        if(helper.getParam("fileId") !== '' && helper.getParam("fileId") !== 'null'){
            fileId = helper.getParam("fileId");
            fileIdParam = "&fileId="+fileId;
        }
        if(shareFileId !== ''){
            fileIdParam = "&fileId="+shareFileId;
            fileId = shareFileId;
        }
        if(path === "/My Docs" || path === "/" || path === "/OneDrive" || path === "OneDrive" || path === "/Sharepoint" || path === "Sharepoint"){
            fileIdParam = "";
            fileId = '';
        }
        this.setState({
            shareFileId: fileId
        })
        if(fileId !== ''){
            requestData['shareFileId'] = fileId;
        }

        if(path === '/'){
            path = '/My Docs';
        }

        requestData['storageTransfers'] = false;
        if(path.indexOf("/Email/Web") !== -1 || path.indexOf("/Email/Outlook") !== -1){
            requestData['storageTransfers'] = true;
            requestData['order'] = 'created_at';
            requestData['order_direction'] = 'desc';
        }

        backPath = this.getBackPath(path);
        history.push("/user/home?dir="+decodeURIComponent(path)+fileIdParam);

        if(path.includes("/OneDrive") || path.includes("/Sharepoint")){
            let isSharePoint = false;
            if(path.includes("/Sharepoint")){
                isSharePoint = true;
            }

            if(isSharePoint && (!helper.isExtensionAllowed(user, 'sharepoint') || !helper.isExtensionEnable(user, 'sharepoint'))){
                return true;
            }else if(!helper.isExtensionAllowed(user, 'one_drive') || !helper.isExtensionEnable(user, 'one_drive')){
                return true;
            }

            if (path === "/OneDrive" || path === "OneDrive" || path === "/Sharepoint" || path === "Sharepoint"){
                let apiUrl = ApiOneDrive;
                if(isSharePoint){
                    apiUrl = ApiSharepoint;
                }
                
                apiUrl.getDriveFiles().then( async dataRe =>  {
                    const getFolderPath = (fullPath) => {
                        const path = fullPath;
                        const dataAfterRoot = path.split("root:")[1];
                        let returnFullPath = decodeURIComponent("/OneDrive"+dataAfterRoot);
                        if(isSharePoint){
                            returnFullPath = decodeURIComponent("/Sharepoint"+dataAfterRoot);
                        }
                        return returnFullPath;
                    };
                    const getFolderPathOneDrive = (fullPath) => {
                        const path = fullPath;
                        const dataAfterRoot = path.split("root:")[1];
                        return dataAfterRoot;
                    };
                    const odataContext1 = dataRe["@odata.context"];
                    const emailRegex = /'([^']+)'/;
                    const match = odataContext1.match(emailRegex);
                    if (match && match.length > 1) {
                        const email = decodeURIComponent(match[1]);
                        this.setState({
                            oneDriveEmail: email
                        })
                        localStorage.setItem("one_drive_email", email);
                    }
                    const data = dataRe.value;
                    
                    const newData =[];
                    for (let index = 0; index < data.length; index++) {
                        const file = data[index];
                        const downloadUrl = file['@microsoft.graph.downloadUrl'];
                        let folderPath = "/OneDrive";
                        let owner = "OneDrive";
                        let transferType = "one_drive";
                        if(isSharePoint){
                            folderPath = "/Sharepoint";
                            owner = "Sharepoint";
                            transferType = "sharepoint";
                        }
                        newData.push({
                            "fileCopyStatus" : false, 
                            "flagStatus" : false,                        
                            "id":data[index].id,
                            "drive_id":data[index].parentReference.driveId,
                            "type":data[index]?.folder ? 'folder' : 'file',
                            "name":data[index].name,
                            "orignalSize":data[index].size,
                            "size": helper.getFormatedSize(data[index].size),
                            "date":data[index].createdDateTime,
                            "modified_date":data[index].lastModifiedDateTime,
                            "owner": owner,
                            "favourite":false,
                            "default":0,
                            "downloadLink":downloadUrl,
                            "recipients":[
                            ],
                            "transfer_type": transferType,                        
                            "path":getFolderPath(data[index]?.parentReference?.path)+"/"+data[index].name,
                            "pathOneDrive":getFolderPathOneDrive(data[index]?.parentReference?.path),
                            "folder_path": folderPath,
                            "relatedLinks":[
                            ],
                            "sharedWith":[
                            ],
                            "versionControl":null,
                            "mime_major":data[index]?.file?.mimeType,
                            "extension": helper.getFileExtension(data[index].name),
                            "created_at":data[index].createdDateTime,
                            "updated_at":data[index].lastModifiedDateTime,
                            "last_modified_by":"",
                            "thumbnails":{
                                'large': downloadUrl,
                                'medium': downloadUrl,
                                'small': downloadUrl
                            },
                            "webLink":data[index].webUrl,
                        })
                    }
                    this.setState({
                        totalItemCount: newData.length,
                        response: newData,
                        loading: false,
                        loadingMore: false,
                    });
                    this.loadingFolder = false;
                }).catch(err => {
                    if('notAllowed' === err || ('invalidRequest' === err && isSharePoint === true)){
                        let redirectUrl = '/user/extensions?showAccessPopup=true&type='+(isSharePoint ? 'sharepoint' : 'onedrive');
                        this.history.push(redirectUrl);

                        // alert('does not have a OneDrive account that is accessible.');
                    }else if ('add Account' === err) {
                        // alert('Please Add Account First!!')
                        var result = window.confirm("Please Add Account First!!");
                        if (result) {
                            this.history.push("/user/extensions");
                        }else{
                            this.history.push("/user/home?dir=/My Docs");
                        }
                        this.setState({
                            loading: false,
                        });
                    }
                    console.log(err);
                });
            }else{
                const driveId = localStorage.getItem("drive_id");
                let folderId = this.getPathFolderId(path);
                if(folderId === null){
                    if(isSharePoint){
                        this.history.push("/user/home?dir=/Sharepoint");
                    }else{
                        this.history.push("/user/home?dir=/OneDrive");
                    }
                    return;
                }

                this.loadOneDriveNested(folderId,driveId);
            }
            if(isSharePoint){
                this.setState({activeTab:2});
            }else{
                this.setState({activeTab:1});
            }
        }else if(path.includes("/GoogleDrive")){
            if(!helper.isExtensionAllowed(user, 'google_drive') || !helper.isExtensionEnable(user, 'google_drive')){
                return true;
            }
            let folderId = this.getPathFolderId(path);

            let params = {
                q: "'root' in parents",
                fields: 'files(id, name, size, mimeType, createdTime, modifiedTime, parents)',
            }
            if(folderId && path !== "/GoogleDrive" && path !== "GoogleDrive"){
                params['q'] = `'${folderId}' in parents`;
            }else if(folderId === null && path !== "/GoogleDrive" && path !== "GoogleDrive"){
                this.history.push("/user/home?dir=/GoogleDrive");
                return;
            }

            ApiGoogleDrive.getDriveFiles(params).then( async response =>  {
                const constructPath = (currentPath, folderName) => {
                    return `${currentPath}/${folderName}`;
                };

                const newPath = path !== "/GoogleDrive" ? path : "/GoogleDrive";
                
                const newData = await Promise.all(
                    response.files.map(async (file) => {
                        const isFolder = file.mimeType === 'application/vnd.google-apps.folder';
                        
                        const downloadUrl = ApiGoogleDrive.getDownloadUrl(file.id, file.mimeType);
                        
                        if(folderId === null){
                            localStorage.setItem("drive_id", file.parents[0]); 
                        }
                        let driveId = localStorage.getItem("drive_id");

                        return {
                            id: file.id,
                            drive_id: driveId,
                            type: isFolder ? 'folder' : 'file',
                            name: file.name,
                            path: constructPath(newPath, file.name),
                            orignalSize: file.size ? file.size : 0,
                            size: file.size ? helper.getFormatedSize(file.size) : '',
                            owner: 'Google Drive',
                            extension: helper.getFileExtension(file.name),
                            mime_major: file?.mimeType,
                            created_at: file.createdTime,
                            date: file.createdTime,
                            updated_at: file.modifiedTime,
                            modified_date: file.modifiedTime,
                            downloadLink: downloadUrl,
                            recipients: [],
                            relatedLinks: [],
                            sharedWith: [],
                        }
                    })
                );

                this.setState({
                    totalItemCount: newData.length,
                    response: newData,
                    loading: false,
                    loadingMore: false,
                });
                this.loadingFolder = false;
            }).catch(err => {

            });
            this.setState({activeTab:3})
        }else{          
            Api.getFiles(requestData, source).then(data => {
                const oldResponse = (viewMore ? this.state.response:[]);
                const response = oldResponse.concat(data.response);
                data.response.map(file => {
                    if(file.favourite){
                        favourites.push(file.id);
                    }
                    return null;
                });
                this.setState({
                    totalItemCount: data.totalItemCount,
                    response: response,
                    loading: false,
                    loadingMore: false,
                    totalPages: data.totalPages,
                    favourites: favourites,
                    sharedWithUsers: ( data.sharedWith ? data.sharedWith : [])
                });
                this.loadingFolder = false;
            }).catch(err => {
                console.log(err);
            });
            localStorage.removeItem('drive_id');

            this.setState({
                activeTab:0,
                breadcrumbData: []
            })

            if(path.includes("/Email/Outlook")){
                this.setState({ transferActiveTab: 2 })
            }else if(path.includes("/Email/Web")){
                this.setState({ transferActiveTab: 1 })
            }else if(path.includes("/Email")){
                this.setState({ transferActiveTab: 0 })
            }
        }
       
        let newState = {
            loading: (!viewMore), 
            loadingMore: viewMore,
            showError: false, 
            cancelToken: source,
            page: page,
            path: path,
            backPath: backPath,
            checked: viewMore ? this.state.checked : [],
            uploadFileModal: false,
            newFolderModal: false,
            newFolderModalOneDrive : false,
            creatingFolder: false,
            copyFilesModal: false,
            CopyMyDocModal: false,
            copyingFilesModal: false,
            copyingMyDocsFilesModal: false,
            moveFilesModal: false,
            movingFilesModal: false,
            renameFileModal: false,
            renamingFileModal: false,
            files: [],
            errorMessage: null,
            checkedAll: false,
            filesCopiedSize: 0,
            canceledCopyingMyDocsFilesModal: false,
            newLinkUploaded: false,
            downloadLink: null
        };
        if(!viewMore){
            newState['totalPages'] = 0;
        }
        this.setState(newState);
        this.loadingFolder = true;
    }
    loadOneDriveNested(folderId,driveId){
        const { path } = this.state;
        this.setState({
            getOneDriveNestedFiles:true
        })
        let isSharePoint = false;
        let apiUrl = ApiOneDrive;
        if(path.includes("/Sharepoint")){
            isSharePoint = true;
            apiUrl = ApiSharepoint;
        }
        apiUrl.getOneDriveNestedFiles(folderId,driveId).then(dataRe => {
            const getFolderPath = (fullPath) => {
                const path = fullPath;
                const dataAfterRoot = path.split("root:")[1];
                let returnFullPath = decodeURIComponent("/OneDrive"+dataAfterRoot);
                if(isSharePoint){
                    returnFullPath = decodeURIComponent("/Sharepoint"+dataAfterRoot);
                }
                return returnFullPath;
            };
            const getFolderPathOneDrive = (fullPath) => {
                const path = fullPath;
                const dataAfterRoot = path.split("root:")[1];
                return dataAfterRoot;
            };
            const odataContext1 = dataRe["@odata.context"];
            const emailRegex = /'([^']+)'/;
            const match = odataContext1.match(emailRegex);
            if (match && match.length > 1) {
                const email = decodeURIComponent(match[1]);
                this.setState({
                    oneDriveEmail: email
                })
            } 
            const data = dataRe.value;
           
            const newData =[]
            for (let index = 0; index < data.length; index++) {
                const file = data[index];
                const downloadUrl = file['@microsoft.graph.downloadUrl'];
                let folderPath = "/OneDrive";
                let owner = "OneDrive";
                let transferType = "one_drive";
                if(isSharePoint){
                    folderPath = "/Sharepoint";
                    owner = "Sharepoint";
                    transferType = "sharepoint";
                }
                newData.push({
                    "id":data[index].id,
                    "drive_id":data[index].parentReference.driveId,
                    "type":data[index]?.folder ? 'folder' : 'file',
                    "name":data[index].name,
                    "orignalSize":data[index].size,
                    "size":helper.getFormatedSize(data[index].size),
                    "date":data[index].createdDateTime,
                    "modified_date":data[index].lastModifiedDateTime,
                    "owner": owner,
                    "favourite":false,
                    "default":0,
                    "downloadLink":downloadUrl,
                    "recipients":[
                    ],
                    "transfer_type": transferType,
                    "pathOneDrive":decodeURIComponent(getFolderPathOneDrive(data[index]?.parentReference?.path)),
                    "path":decodeURIComponent(getFolderPath(data[index]?.parentReference?.path)+"/"+data[index].name),
                    "folder_path": folderPath,
                    "relatedLinks":[
                    ],
                    "sharedWith":[
                    ],
                    "versionControl":null,
                    "mime_major":data[index]?.file?.mimeType,
                    "extension": helper.getFileExtension(data[index].name),
                    "created_at":data[index].createdDateTime,
                    "updated_at":data[index].lastModifiedDateTime,
                    "last_modified_by":"",
                    "thumbnails":{
                        'large': downloadUrl,
                        'medium': downloadUrl,
                        'small': downloadUrl
                    },
                    "webLink":data[index].webUrl,
                })
            }
            this.setState({
                totalItemCount: newData.length,
                response: newData,
                loading: false,
                loadingMore: false,
            });
            this.loadingFolder = false;
        }).catch(err => {
            console.log(err);
        });
    }
    getPathFolderId(path){
        const { breadcrumbData } = this.state;

        const folder = breadcrumbData.find((breadcrumb) => breadcrumb.path === path);

        if (folder) {
            return folder.id;
        }
        return null;
    }
    checkFileSize(){
        const { user } = this.store.getState();
        const files = this.getCheckedFiles()
        const totalFileSize = files.reduce((accumulator, obj) => accumulator + Number(obj.orignalSize), 0);
        const leftMemorySize = (user.quota - user.usage); 

        if (leftMemorySize < totalFileSize ) {
            alert('Not enough storage space in My Docs');
            return false
        }
        return true
    }
    convertDateFormet(inputDateTime){
        const dateObj = new Date(inputDateTime);
        const formattedDateTime = dateObj.toISOString().replace("T", " ").replace("Z", "");
        return formattedDateTime.split(".")[0]
    }
    getBackPath(path){
        if(typeof(path) !== "string" || path.trim().length <= 0){
            return "";
        }
        if(path.length <= 1 || path.trim() === "/"){
            return "";
        }
        if(path.substr(0, 1) !== "/"){
            path += "/";
        }
        path = decodeURIComponent(path.trim()); //Decode path
        path = path.replace(/^\/+|\/+$/g, ''); //Remove trailing slash
        const pathArray = path.split("/");
        pathArray.pop();
        let backPath = pathArray.join("/");
        if(backPath.length <= 0){
            backPath = "/";
        }
        if (backPath.includes('OneDrive')) {
            backPath = '/'+backPath;
        }
        return backPath;
    }
    handleToggle(file, onContextMenu = false) {
        if(this.loadingFolder || file.id === 0){
            return;
        }
        // if(file.default){
        //     return;
        // }
        
        let newChecked = [];
        if(onContextMenu || this.state.detailsSection){
            newChecked = [file.id];
        }else{
            const { checked } = this.state;
            const currentIndex = checked.indexOf(file.id);
            newChecked = [...checked];
        
            if (currentIndex === -1) {
                newChecked.push(file.id);
            } else {
                newChecked.splice(currentIndex, 1);
            }
        }

        const downloadFile = (newChecked.length === 1 && file.type === "file");
        this.setState({
            checked: newChecked,
            downloadFile: downloadFile,
            file: (downloadFile ? this.getCheckedFile(newChecked) : null),
            detailsSection: newChecked.length > 0 && this.state.detailsSection ? true : false
        });
    }
    onToggleAllFiles(e){
        if(this.loadingFolder){
            return;
        }

        const checkedFiles = [];
        if(e.target.checked){
            const { response } = this.state;

            response && response.map((file, key) => {
                checkedFiles.push(file.id);
                return null;
            });
        }
        
        this.setState({
            checkedAll: !this.state.checkedAll,
            checked: checkedFiles
        });
    }
    openFileModal(file){
        if(this.loadingFolder){
            return;
        }
        const { user } = this.store.getState();
        let newChecked = [file.id];
        const downloadFile = (newChecked.length === 1 && file.type === "file");
        this.setState({
            checked: newChecked,
            downloadFile: downloadFile,
            file: (downloadFile ? this.getCheckedFile(newChecked) : null)
        },() => {
            if(helper.hasThumbnail(file)){
                this.onImagePreviewModal(true);
            }else if(helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') && helper.isOfficeDocument(file)){
                this.onOfficeFileModal('view');
            }else if(helper.isPdfDocument(file)){
                this.onPdfFileModal(true);
            }else{
                this.onNoPreviewModal(true)
            }
        });
    }
    getTableData(){
        const { classes } = this.props;
        const { response, checked, backPath } = this.state;
        if(response === null){
            return [];
        }
        let tableData = [];
        if(backPath.length > 0 && false){
            let fileArray = {
                id: 0,
                check: "",
                orignalName: "",
                name: (
                    <Link href="/user/home" onClick={(e) => {e.preventDefault(); this.loadFiles(false, null, backPath);}}>
                        <Button justIcon color="transparent" className={classes.fileIcon}>
                            { helper.getFolderIcon() }
                        </Button>
                        {"..."}
                    </Link>
                ),
                orignalSize: "",
                size: "",
                date: "",
                owner: "",
                folderPath: "",
                recipients: "",
                selectMenu: ""
            };
            tableData.push(fileArray);
        }
        let {  path } = this.state;
        let newChecked = [];
      
        newChecked = [...checked];
        response && response.map(file => {
             if((file.type === "folder" && file.path === "/My Docs") || (file.path === "/OneDrive" && file.type === "folder")){
                return null;
            }
          
            if ( path.includes("/OneDrive")){
                if(file.flagStatus){
                    const currentIndex = newChecked.indexOf(file.id);
                    if (currentIndex === -1) {
                        newChecked.push(file.id);
                        this.setState({
                            checked: newChecked,
                        });
                    }
                }
           
             }
 
            let fileArray = {
                id: file.id,
                default: file.name,
                type: file.type,
                downloadLink: file?.downloadLink ? file?.downloadLink :  file['@microsoft.graph.downloadUrl'],
                check: (
                    <Checkbox
                        tabIndex={-1}
                        checked={checked.includes(file.id) }
                        className={classes.positionAbsolute}
                        onClick={() => this.handleToggle(file)}
                         checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        disabled={(file.default === 1)}
                        classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                        }}
                    />
                ),
                orignalName: file.name,
                name: (
                    <ContextMenuTrigger id="file_dropdown_menu" collect={() => {return file}}>
                        {this.getFileName(file)}
                    </ContextMenuTrigger>
                ),
                orignalSize: file.orignalSize,
                size: file.size,
                date: file?.updated_at ?  this.convertDateFormet(file?.updated_at) : file?.lastModifiedDateTime,
                owner: file?.owner,
                lastModifiedBy: file?.last_modified_by ?file?.last_modified_by : file?.lastModifiedDateTime,
                recipients: (
                    <div className={classes.recipients}>{this.getRecipients(file)}</div>
                ),
                folderPath: file?.folder_path,
                relatedLinks: this.getRelatedLink(file),
                selectMenu: (
                    <div className='file-menu-icon' onClick={(e) => this.handleLeftMenuClick(e, file)}>
                        <svg width="6" height="22" viewBox="0 0 6 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.75 16.5C2.38533 16.5 2.03559 16.6449 1.77773 16.9027C1.51987 17.1606 1.375 17.5103 1.375 17.875C1.375 18.2397 1.51987 18.5894 1.77773 18.8473C2.03559 19.1051 2.38533 19.25 2.75 19.25C3.11467 19.25 3.46441 19.1051 3.72227 18.8473C3.98013 18.5894 4.125 18.2397 4.125 17.875C4.125 17.5103 3.98013 17.1606 3.72227 16.9027C3.46441 16.6449 3.11467 16.5 2.75 16.5ZM2.75 9.625C2.38533 9.625 2.03559 9.76987 1.77773 10.0277C1.51987 10.2856 1.375 10.6353 1.375 11C1.375 11.3647 1.51987 11.7144 1.77773 11.9723C2.03559 12.2301 2.38533 12.375 2.75 12.375C3.11467 12.375 3.46441 12.2301 3.72227 11.9723C3.98013 11.7144 4.125 11.3647 4.125 11C4.125 10.6353 3.98013 10.2856 3.72227 10.0277C3.46441 9.76987 3.11467 9.625 2.75 9.625ZM4.125 4.125C4.125 3.76033 3.98013 3.41059 3.72227 3.15273C3.46441 2.89487 3.11467 2.75 2.75 2.75C2.38533 2.75 2.03559 2.89487 1.77773 3.15273C1.51987 3.41059 1.375 3.76033 1.375 4.125C1.375 4.48967 1.51987 4.83941 1.77773 5.09727C2.03559 5.35513 2.38533 5.5 2.75 5.5C3.11467 5.5 3.46441 5.35513 3.72227 5.09727C3.98013 4.83941 4.125 4.48967 4.125 4.125Z"/>
                        </svg>
                    </div>
                ),
                path: file?.path,
                thumbnails: file?.thumbnails,
                extension: file?.extension,
                drive_id: file?.drive_id,
            };
            tableData.push(fileArray);
            return null;
            
        });
            
        return tableData;
    }
    getFileName(file){
        const modificationAllowed = this.isModificationAllowed();
        const { classes } = this.props;
        const { favourites } = this.state;
        let shareFileId = '';
        if(file.hasOwnProperty("sharedWith") && file.sharedWith.length > 0){
            shareFileId = file.id;
        }
        return (
            <div title={file.name} className='file-name'>
                <div>
                    {
                        file.type === "folder" ?
                            <Link href={"/user/home"} onClick={(e) => this.loadFolder(e, file, shareFileId)}>
                                <Button justIcon color="transparent" className={classes.fileIcon}>
                                    {
                                        file.hasOwnProperty("sharedWith") && file.sharedWith.length > 0 ?
                                            helper.getFolderIcon(true)                               
                                        :
                                            helper.getFolderIcon()                                                                
                                    }
                                </Button>
                                { file.name }
                            </Link>
                        :
                            <>
                                { 
                                    helper.getFileIcon(file, classes, modificationAllowed)
                                }
                                { file.name }
                            </>
                    }
                </div>
                <Button justIcon color="transparent" className={classes.fileIcon+" star-icon"} onClick={() => this.favourite(file)}>
                    {
                        favourites.includes(file.id) ?
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.31605 0.511466C8.1655 0.198904 7.84735 0 7.49796 0C7.14857 0 6.83326 0.198904 6.67987 0.511466L4.85336 4.27074L0.774248 4.87314C0.433375 4.92428 0.149315 5.16297 0.0442125 5.48974C-0.0608899 5.81651 0.0243281 6.17737 0.26862 6.4189L3.22853 9.34846L2.52974 13.4885C2.47293 13.8295 2.61496 14.1761 2.89618 14.3779C3.1774 14.5796 3.54952 14.6052 3.8563 14.4432L7.5008 12.4968L11.1453 14.4432C11.4521 14.6052 11.8242 14.5825 12.1054 14.3779C12.3866 14.1733 12.5287 13.8295 12.4719 13.4885L11.7702 9.34846L14.7301 6.4189C14.9744 6.17737 15.0625 5.81651 14.9545 5.48974C14.8466 5.16297 14.5654 4.92428 14.2245 4.87314L10.1426 4.27074L8.31605 0.511466Z"/>
                            </svg>                        
                        :
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.75357 4.79753L7.49833 1.20222L9.24309 4.79753C9.37381 5.06753 9.62955 5.25511 9.92793 5.30059L13.8323 5.87754L10.9964 8.68557C10.7861 8.89305 10.6895 9.19147 10.7406 9.48421L11.4084 13.449L7.92742 11.5874C7.66031 11.4453 7.3392 11.4453 7.06925 11.5874L3.58541 13.449L4.25319 9.48421C4.3015 9.19147 4.20773 8.89589 3.99745 8.68557L1.16434 5.87754L5.06874 5.30059C5.36711 5.25796 5.62286 5.06753 5.75357 4.79753ZM11.3914 14.4693C11.6215 14.5915 11.9 14.5745 12.1103 14.421C12.3206 14.2675 12.4286 14.0089 12.3859 13.7531L11.6386 9.33358L14.7985 6.20154C14.9832 6.01965 15.0457 5.74964 14.9661 5.50522C14.8866 5.2608 14.6734 5.08174 14.4177 5.04195L10.0615 4.39963L8.11213 0.383689C7.99846 0.147791 7.75976 0 7.49833 0C7.2369 0 6.99821 0.147791 6.88454 0.383689L4.93518 4.39963L0.58181 5.04479C0.326063 5.08174 0.112941 5.2608 0.0333752 5.50806C-0.0461904 5.75533 0.0191671 6.02249 0.201031 6.20439L3.35808 9.33358L2.61357 13.7531C2.57095 14.0089 2.67609 14.2675 2.88921 14.421C3.10233 14.5745 3.38081 14.5915 3.60814 14.4693L7.50118 12.3889L11.3942 14.4693H11.3914Z"/>
                            </svg>
                    }
                </Button>
            </div>
        )
    }
    getFileNameGrid(file){
        const modificationAllowed = this.isModificationAllowed();
        
        const { classes } = this.props;
        const { checked } = this.state;

        let shareFileId = '';
        if(file.hasOwnProperty("sharedWith") && file.sharedWith.length > 0){
            shareFileId = file.id;
        }
        return (
            <div title={file.name} className={"file-content "+(checked.includes(file.id) ? 'checked' : '')}  onClick={(e) => this.handleToggle(file)} onDoubleClick={file.type === 'folder' ? (e) => this.loadFolder(e, file, shareFileId) : (e) => this.openFileModal(file)}>
                <span className="checked-icon">
                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1L4.9375 3L2.875 5L1 3.18182" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
                {
                    file.type === "folder" ?
                        <>
                            <div className='thumbnail-icon'>
                                <Button justIcon color="transparent" className={classes.fileIcon}>
                                    {
                                        file.hasOwnProperty("sharedWith") && file.sharedWith.length > 0 ?
                                            helper.getFolderIcon(true)
                                        :
                                            helper.getFolderIcon()
                                    }
                                </Button>
                            </div>
                            <div className='filename-section'>
                                <div className='filename'>
                                    <Link href={"/user/home"} onClick={(e) => this.loadFolder(e, file, shareFileId)}>
                                        {file.name}
                                    </Link>
                                </div>
                                <div className="file-menu-icon" onClick={(e) => this.handleLeftMenuClick(e, file)}>
                                    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.4874 0.512567C12.804 -0.170848 11.696 -0.170848 11.0126 0.512567C10.3291 1.19598 10.3291 2.30402 11.0126 2.98744C11.696 3.67085 12.804 3.67085 13.4874 2.98744C14.1709 2.30405 14.1709 1.19601 13.4874 0.512567Z"/>
                                        <path d="M8.23744 0.512567C7.55402 -0.170848 6.44598 -0.170848 5.76257 0.512567C5.07915 1.19598 5.07915 2.30402 5.76257 2.98744C6.44598 3.67085 7.55402 3.67085 8.23744 2.98744C8.92085 2.30405 8.92085 1.19601 8.23744 0.512567Z"/>
                                        <path d="M2.98744 0.512567C2.30402 -0.170848 1.19598 -0.170848 0.512564 0.512567C-0.170852 1.19598 -0.170852 2.30402 0.512564 2.98744C1.19598 3.67085 2.30402 3.67085 2.98744 2.98744C3.67085 2.30405 3.67085 1.19601 2.98744 0.512567Z"/>
                                    </svg>
                                </div>
                            </div>
                        </>
                    :
                        <>
                            <div className='thumbnail-icon'>
                                { 
                                    helper.getFileIcon(file, classes, modificationAllowed, true)
                                }
                            </div>
                            <div className='filename-section'>
                                <div className='filename'>{file.name}</div>
                                <div className="file-menu-icon" onClick={(e) => this.handleLeftMenuClick(e, file)}>
                                    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.4874 0.512567C12.804 -0.170848 11.696 -0.170848 11.0126 0.512567C10.3291 1.19598 10.3291 2.30402 11.0126 2.98744C11.696 3.67085 12.804 3.67085 13.4874 2.98744C14.1709 2.30405 14.1709 1.19601 13.4874 0.512567Z"/>
                                        <path d="M8.23744 0.512567C7.55402 -0.170848 6.44598 -0.170848 5.76257 0.512567C5.07915 1.19598 5.07915 2.30402 5.76257 2.98744C6.44598 3.67085 7.55402 3.67085 8.23744 2.98744C8.92085 2.30405 8.92085 1.19601 8.23744 0.512567Z"/>
                                        <path d="M2.98744 0.512567C2.30402 -0.170848 1.19598 -0.170848 0.512564 0.512567C-0.170852 1.19598 -0.170852 2.30402 0.512564 2.98744C1.19598 3.67085 2.30402 3.67085 2.98744 2.98744C3.67085 2.30405 3.67085 1.19601 2.98744 0.512567Z"/>
                                    </svg>
                                </div>
                            </div>
                        </>
                }
            </div>
        )
    }
    openRecipientLinks(email){
        let url = "/user/links?page=1&recipientEmail="+email;
        this.history.push(url);
    }
    getRecipients(file){
        if(file.transfer_type === "share"){
            return <div>Anyone (links only)</div>;
        }
        // if(file?.recipients.length <= 1){
        //     return <div>{file.recipients.join(",")}</div>;
        // }
        const firstTwoRecipients = file.recipients.slice(0, 2);
        let recipientsList = [];
        file.recipients.map((email, key) => {
            recipientsList.push(
                <li key={key} onClick={() => this.openRecipientLinks(email)}>{email}</li>
            );
            return null;
        });
        return (
            <>
                <div>
                    <span className='recipients-list'>{firstTwoRecipients.join(" , ")}</span>
                    {
                        file.recipients.length > 1 ?
                            <span className='recipients-count'>({file.recipients.length})</span>
                        :
                            <></>
                    }
                </div>
                <ul>
                    {recipientsList}
                </ul>
            </>
        );
    }
    getRelatedLink(file){
        if(file.relatedLinks.length <= 0){
            return null;
        }
        const url = "/user/links?page=1&links="+file.relatedLinks.join(",");
        return (
            <RouterLink to={url}>
                {
                    file.relatedLinks.length+" "+(file.relatedLinks.length > 1 ? 'links' : 'link')
                }
            </RouterLink>
        );
    }
    onRelatedLinks(){
        const { checked, response, path } = this.state;
        if(checked.length <= 0){
            return;
        }

        let url = "/user/links?page=1&files="+checked.join(",");

        if(path.indexOf("/Email/Web") !== -1 || path.indexOf("/Email/Outlook") !== -1){
            let relatedLinks = [];
            response && response.map(file => {
                if(checked.includes(file.id)){
                    if(file.relatedLinks.length > 0){
                        relatedLinks.push(file.relatedLinks);
                    }
                }
                return null;
            })
            relatedLinks = [].concat(...relatedLinks);

            if(relatedLinks.length > 0){
                url = "/user/links?page=1&links="+relatedLinks.join(",");
            }
        }

        this.history.push(url);
    }
    isRelatedLinkEnable(){
        const { checked, response } = this.state;
        if(checked.length <= 0){
            return false;
        }

        let haveRelatedLink = false;
        response && response.map(file => {
            if(checked.includes(file.id)){
                if(file.relatedLinks.length > 0){
                    haveRelatedLink = true;
                }
            }
            return null;
        })
        
        return haveRelatedLink;
    }
    loadFolder(e, parent, shareFileId = null){
        e.preventDefault();

        localStorage.setItem("drive_id", parent.drive_id);

        const { breadcrumbData } = this.state;
        const updatedBreadcrumbs = breadcrumbData.some((breadcrumb) => breadcrumb.path === parent.path) ? 
            breadcrumbData.map((breadcrumb) =>
                breadcrumb.path === parent.path
                    ? { ...breadcrumb, id: parent.id } 
                    : breadcrumb
                )
        : 
            [
                ...breadcrumbData,
                { id: parent.id, path: parent.path }, 
            ];
            

        this.setState({
            path: parent.path,
            shareFileId: shareFileId,
            breadcrumbData: updatedBreadcrumbs
        }, () => {
            this.loadFiles(false);
        });
    }
    getTrProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            let shareFileId = '';
            if(rowInfo.original.hasOwnProperty("sharedWith") && rowInfo.original.sharedWith.length > 0){
                shareFileId = rowInfo.original.id;
            }
            
            return {
                onClick: (e) => this.handleToggle(rowInfo.original),
                onDoubleClick: rowInfo.original.type === 'folder' ? (e) => this.loadFolder(e, rowInfo.original, shareFileId) : (e) => this.openFileModal(rowInfo.original)
            }
        }else{
            return {}
        }
    }
    getTrGroupProps(state, rowInfo){
        const { backPath, checked } = this.state;
        if(backPath.length <= 0){
            return {};
        }
        if (rowInfo && rowInfo.row) {
            if(checked.indexOf(rowInfo.original.id) !== -1){
                return {
                    className: 'selected_row'
                }
            }
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    deleteSelected(){
        const { checked } = this.state;

        if(checked.length <= 0){
            return;
        }
        this.setState({deleteFileModal: true});
    }
    onModalClose(deleteFileModal = true){
        let checked = this.state.checked;
        if(deleteFileModal === false){
            checked = [];
        }
        this.setState({
            deleteFileModal: deleteFileModal,
            checked: checked,
            deleteAll: false,
            checkedAll: false,
        });
    }
    onModalSuccess(){
        const { shareFileId, checked, response } = this.state;
        const checkedFiles = this.getCheckedFiles();
        
        const source = axios.CancelToken.source();
        const requestData = {
            files: checked,
        };
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
        }
        Api.deleteFiles(requestData, source).then(data => {
            let newResponse = [];
            response && response.map(file => {
                if(!checked.includes(file.id)){
                    newResponse.push(file);
                }
                return null;
            });
            this.setState({
                response: newResponse,
                checked: [],
                deleteFileModal: false,
                deleteAll: false,
                checkedAll: false,
                saving: false,
                errorMessage: null,
                deleteSnackbarOpen: true,
                deleteFilesCount: checkedFiles.length
            });
        }).catch(err => {
            this.setState({
                saving: false,
                errorMessage: err.message
            });
        });
        this.setState({
            saving: true
        });
    }
    onDrop(filesArray){
        this.store.dispatch({ type: 'UPDATE_STATE', state: {
            customState: {
                uploadFileModal: true, 
                type: 'upload', 
                sharedWithUsers: this.state.sharedWithUsers,
                shareFileId: this.state.shareFileId, 
                path: this.state.path,
                files: filesArray,
            }
        }});
    }
    onUploadModal(uploadFileModal = true, type = 'file'){
        if(!uploadFileModal){
            if(this.state.resetComponent){
                this.store.dispatch({ type: 'UPDATE_STATE', state: {
                    customState: null
                }});
            }
            this.loadFiles(false);
            return;
        }
        this.setState({
            uploadFileModal: uploadFileModal,
            uploadType: type,
            uploadMenuEl: null,
        });

        this.store.dispatch({ type: 'UPDATE_STATE', state: {
            customState: {
                uploadFileModal: true, 
                type: 'upload', 
                sharedWithUsers: this.state.sharedWithUsers,
                shareFileId: this.state.shareFileId, 
                uploadType: type,
                path: this.state.path
            }
        }});
    }
    favourite(file){
        const { favourites } = this.state;
        const currentIndex = favourites.indexOf(file.id);
        const newFavourites = [...favourites];
        if (currentIndex === -1) {
            newFavourites.push(file.id);
        } else {
            newFavourites.splice(currentIndex, 1);
        }

        const source = axios.CancelToken.source();
        const requestData = {
            file_id: file.id
        }
        Api.favouriteFile(requestData, source).then(data => {
            
        }).catch(err => {
            console.log(err);
        });
        this.setState({
            favourites: newFavourites
        }, () => {
            this.handleToggle(file);
        });
    }
    havePdfFile(){
        const { checked } = this.state;

        let havePdfFile = false;
        checked.forEach(fileId => {
            const file = this.getCheckedFile([fileId]);
            if(helper.isPdfDocument(file)){
                havePdfFile = true;
            }
        });

        return havePdfFile;
    }
    onLinkName(status = false){
        const { createLinkState } = this.store.getState();
        const { checked } = this.state;
        if(checked.length <= 0){
            return;
        }

        this.setState({
            linkName: status,
            shareFileModal: status,
        },() => {
            if(!status && createLinkState){
                this.store.dispatch({ type: 'UPDATE_STATE', state: {
                    createLinkState: null,
                }});
            }
        });
    }
    onShareModal(status = false, linkTitle = null, linkPassword = null, expire = '', pdfTracking = false, requireVerification = false, permittedEmails = []){
        const { checked, path } = this.state;
        if(checked.length <= 0){
            return;
        }

        const source = axios.CancelToken.source();
        const requestData = {
            files: checked,
            path: path,
            pdf_tracking: pdfTracking ? 1 : 0,
            requireVerification: requireVerification ? true : false
        };
        if(requireVerification && Array.isArray(permittedEmails) && permittedEmails.length > 0){
            requestData['recipients'] = permittedEmails;
        }
        if(typeof(path) === "string" && path.indexOf("/My Docs") !== -1){
            requestData['uploadType'] = "my_docs";
        }
        if(linkTitle !== null){
            requestData['linkTitle'] = linkTitle;
        }
        if(linkPassword !== null){
            requestData['linkPassword'] = linkPassword;
        }
        if(expire !== ''){
            requestData['expire'] = expire;
        }
        
        Api.shareFiles(requestData, source).then(data => {
            if(data.status === 'uploaded'){
                this.setState({
                    sharingFiles: false,
                    newLinkUploaded: true
                })

                return;
            }
            
            let downloadLink = "/downloads/"+data.hash;
            this.setState({sharingFiles: false, newLinkUploaded: false, downloadLink: downloadLink, linkHash: data.hash});
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({cancelToken: null, errorMessage: err.message, sharingFiles: false});
            }
        });
        this.setState({
            shareFileModal: status,
            sharingFiles: status,
            cancelToken: source,
            linkName: false
        });
    }
    onAdvShareModal(status = false){
        const { checked } = this.state;
        if(checked.length <= 0){
            return;
        }
        
        this.setState({
            advShareModal: status,
        });
        if(!status){
            this.loadFiles();
        }
    }
    onShareModalSuccess(){
        const { createLinkState } = this.store.getState();

        this.setState({
            shareFileModal: false,
            linkName: false,
            errorMessage: null,
            newLinkUploaded: false,
            downloadLink: null
        });

        if(createLinkState){
            this.store.dispatch({ type: 'UPDATE_STATE', state: {
                createLinkState: null,
            }});
        }else{
            this.loadFiles();
        }
    }
    onDownloadModal(status = false) {
        const { checked, path, downloadFile, file, shareFileId } = this.state;
        
        if (checked.length <= 0) {
            return;
        }

        if (downloadFile && checked.length === 1 && file) {
            try {
                const downloadLink = file.downloadLink;
                const fileName = file.name || 'download';
                
                const a = document.createElement('a');
                a.href = downloadLink;
                a.download = fileName;
                a.style.display = 'none';
                
                document.body.appendChild(a);
                a.click();
                
                setTimeout(() => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(downloadLink);
                }, 100);
                
                this.trackFileDownload([file.id], shareFileId);
            } catch (error) {
                console.error('Download failed:', error);
            }
            return;
        }


        try {
            const checkedFiles = this.getCheckedFiles();
            const currentState = this.props.store.getState();
            const existingDownloads = (currentState.downloadProcessState?.downloads || []);
            
            const newDownload = {
                downloadId: Date.now(),
                files: checkedFiles,
                path: path,
                shareFileId: shareFileId,
                status: 'pending',
                timestamp: new Date().toISOString(),
                error: null,
                fileCount: checkedFiles.length,
                completedCount: 0
            };
            
            this.props.store.dispatch({
                type: 'UPDATE_STATE',
                state: {
                    downloadProcessState: {
                        ...currentState.downloadProcessState,
                        downloadProcessModal: true,
                        files: checkedFiles,
                        path: path,
                        shareFileId: shareFileId,
                        downloads: [...existingDownloads, newDownload]
                    }
                }
            });
        } catch (error) {
            console.error('Error initializing download:', error);
        }
    }
    trackFileDownload(fileIds = null, fileShareId = null) {
        const { shareFileId, checked } = this.state;
        const idsToTrack = fileIds || checked;
        const shareId = fileShareId || shareFileId;
        
        if (!idsToTrack || idsToTrack.length <= 0) {
            return Promise.resolve({ success: false, message: 'No files to track' });
        }
        
        const source = axios.CancelToken.source();
        const requestData = {
            id: Array.isArray(idsToTrack) ? idsToTrack : [idsToTrack],
            file_id: shareId,
        };
        
        return Api.trackFileDownload(requestData, source)
            .then(response => {
                return { success: true, data: response };
            })
            .catch(error => {
                return { success: false, error: error.message };
            })
            .finally(() => {
                source.cancel('Request completed');
            });
    }
    onDownloadModalSuccess(){
        this.setState({
            downloadModal: false,
            errorMessage: null
        });
        const { downloadUrl } = this.state;
        if(downloadUrl.length > 0){
            window.location.href = downloadUrl;
            this.trackFileDownload();
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getBreadCrumbs(){
        let { path } = this.state;
        let breadcrumbs = [];
        if(path === "/" || path === "/OneDrive" || path === "OneDrive" || path === "/Sharepoint" || path === "Sharepoint"  || path === "/GoogleDrive" || path === "GoogleDrive"){
            return breadcrumbs;
        }
        if (path.indexOf("/My Docs") !== -1) {
            // let breadcrumbs = [{
            //     value: "/",
            //     label: "Home"
            // }];
        }
        if(path === "/"){
            return breadcrumbs;
        }
        if(path.substr(0,1) === "/"){
            path = path.substr(1);
        }
        const pathArray = path.split("/");
        let newPath = "";
        pathArray.map(path => {
            newPath += "/"+path;
            if(path === 'My Docs'){
                path = 'All Files';
            }
            breadcrumbs.push({
                value: newPath,
                label: path
            });
            return null;
        });
        return breadcrumbs;
    }
    getBreadCrumbsOneDrive(){
        let { path } = this.state;
        let breadcrumbs = [];
        if(path === "/"){
            return breadcrumbs;
        }
        if(path.substr(0,1) === "/"){
            path = path.substr(1);
        }
        const pathArray = path.split("/");
        let newPath = "";
        pathArray.map(path => {
            if ("MyDocs" === path) {
                return null;
            }
            if ("/OneDrive" === path) {
                newPath += "/"+path;
                breadcrumbs.push({
                    value: "/OneDrive",
                    label: path
                });
            }else if("/Sharepoint" === path) {
                newPath += "/"+path;
                breadcrumbs.push({
                    value: "/Sharepoint",
                    label: path
                });
            }else{
                newPath += "/"+path;
                breadcrumbs.push({
                    value: newPath,
                    label: path
                });
            }
            return null;
        });

        return breadcrumbs;
    }
    onNewFolderModal(status = false){
        this.setState({
            docMenuEl: null,
            newFolderModal: status,
        });
    }
    onNewFolderModalSuccess(folderName){
        const { shareFileId } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            creatingFolder: true,
            cancelToken: source,
        });
        const requestData = {
            folderName: folderName,
            path: this.state.path
        }
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
            requestData['sharedSection'] = false;
        }
        Api.addNewFolder(requestData, source).then(data => {
            this.setState({
                createSnackbarOpen: true,
                createSnackbarName: folderName,
                createSnackbarPath: this.getLastPart(this.state.path),
                createSnackbarType: 'folder',
            }, () => {
                this.loadFiles();
            });
        }).catch(err => {
            console.log(err);
        });
    }
    getLastPart(path){
        const parts = path.split('/');
        return parts[parts.length - 1];
    }
    getColumns(){
        const { classes } = this.props;
        const { path, shareFileId, searchFormData } = this.state;
        
        let header = "";
        if(path.indexOf("/My Docs") !== -1){
            header = (
                <Checkbox
                    tabIndex={-1}
                    checked={this.state.checkedAll}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    onChange={(e) => this.onToggleAllFiles(e)}
                    classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                    }}
                />
            )
        }

        let columns = [
            {
                Header: header,
                accessor: "check",
                sortable: false,
                filterable: false,
                headerClassName: "hd_check",
                className: "hd_check td_check",
                resizable: false
            },
            {
                Header: "Name",
                accessor: "orignalName",
                headerClassName: "hd_name hd_show_head",
                className: "hd_name td_name td_hide",
                resizable: false,
                sortMethod: (a, b) => {
                    const aDate = new Date(a).getTime();
                    const bDate = new Date(b).getTime();
                
                    if (!isNaN(aDate) && !isNaN(bDate)) {
                        return bDate - aDate; 
                    }
                
                    if (!isNaN(a) && !isNaN(b)) {
                        return b - a; 
                    }
                
                    return String(a).localeCompare(String(b));
                },
            },
            {
                Header: "Name",
                accessor: "name",
                headerClassName: "hd_name hd_hide",
                className: "hd_name td_name",
                sortable: false,
            },
            {
                Header: "Last Modified",
                accessor: "date",
                headerClassName: "hd_creation_date",
                className: "hd_creation_date td_creation_date",
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                  if(a1<b1)
                    return 1;
                  else if(a1>b1)
                    return -1;
                  else
                    return 0;
                }
            },
            {
                Header: "Size",
                accessor: "orignalSize",
                headerClassName: "hd_size hd_show_head",
                className: "hd_size td_size td_hide",
                resizable: false
            },
            {
                Header: "Size",
                accessor: "size",
                headerClassName: "hd_size hd_hide",
                className: "hd_size td_size",
                sortable: false,
            },
            {
                Header: "Creator",
                accessor: "owner",
                headerClassName: "hd_owner",
                className: "hd_owner td_owner",
            }
        ];
        if((path !== "/Email" && path !== "/OneDrive" && !path.includes("/OneDrive")) && (path !== "/Sharepoint" && !path.includes("/Sharepoint")) && (path !== "/GoogleDrive" && !path.includes("/GoogleDrive"))){
            columns.push({
                Header: "Related Links",
                accessor: "relatedLinks",
                headerClassName: "hd_related_links",
                className: "hd_related_links td_creation_date",
            });
        }
        if(path !== "/" && path !== "/Email" && path !== "/Email/Outlook" && path !== "/My Docs" && !path.includes("/My Docs") && path !== "/OneDrive" && !path.includes("/OneDrive") && path !== "/Sharepoint" && !path.includes("/Sharepoint") && path !== "/GoogleDrive" && !path.includes("/GoogleDrive")){
            columns.push({
                Header: "Recipient(s)",
                accessor: "recipients",
                headerClassName: "td_recipients",
                className: "hd_recipients td_recipients",
            });
        }
        if(shareFileId !== ''){
            columns.push({
                Header: "Last Modified By",
                accessor: "lastModifiedBy",
                headerClassName: "hd_owner",
                className: "hd_owner td_owner",
            });
        }
        if(searchFormData.search || searchFormData.startDate || searchFormData.endDate){
            columns.push({
                Header: "Folder Path",
                accessor: "folderPath",
                headerClassName: "hd_path",
                className: "hd_path td_path",
            });
        }
        columns.push({
            Header: "",
            accessor: "selectMenu",
            headerClassName: "hd_select_menu",
            className: "hd_select_menu td_select_menu",
            sortable: false,
            filterable: false,
            resizable: false
        });

        return columns;
    }
    onContextMenuItemClick(type, data){
        const checkedFile = this.getCheckedFile();
        switch(type){
            case 'share':
                this.onShareModal(true);
                break;
            case 'delete':
                this.deleteSelected();
                break;
            case 'download':
                this.onDownloadModal(true);
                break;
            case 'copy':
                this.onCopyModal(true);
                break;
            case 'move':
                this.onMoveModal(true);
                break;
            case 'rename':
                this.onRenameModal(true);
                break;
            case 'advShare':
            case 'permission':
                this.onAdvShareModal(true);
                break;
            case 'replace':
                this.onManageVersions(true);
                break;
            case 'view':
                this.onOfficeFileModal('view');
                break;
            case 'edit':
                if(checkedFile.extension === "wopitest" || checkedFile.extension === "wopitestx"){
                    this.onOfficeFileModal('edit');
                }else{
                    this.editOfficeDoc(checkedFile);
                }
                break;
            case 'imagePreview':
                this.onImagePreviewModal(true);
                break;
            case 'pdfPreview':
                this.onPdfFileModal(true);
                break;
            case 'detail':
                this.onDetailPreviewSection(true);
                break;
            case 'sign':
                this.onSignDocument(true);
                break;
            case 'adobesign':
                this.onAdobeSignDocument(true);
                break;
            default:
                break;
        }
    }
    onDetailPreviewSection(status = false){
        let state = {};
        state['detailsSection'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state);
    }
    onPdfFileModal(status = false){
        console.log(this.state);
        let state = {};
        state['pdfFileModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    onNoPreviewModal(status = false){
        let state = {};
        state['noPreviewModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    onImagePreviewModal(status = false){
        let state = {};
        state['imagePreviewModal'] = status;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    editOfficeDoc(file, newFile = false){
        let expiresAt = Cookie.read("expires_at");
        if(!expiresAt || expiresAt === "null"){
            expiresAt = 0;
        }
        let url = window.location.origin+"/document/edit/"+file.id;
        if(newFile){
            url = window.location.origin+"/document/editnew/"+file.id;
        }
        // this.editDocTokenRef.current.value = Cookie.read("oauth_token")+":"+Cookie.read("oauth_secret");
        this.editDocRef.current.setAttribute("action", url);
        this.editDocRef.current.submit();
    }
    onOfficeFileModal(action, status = true){
        let state = {};
        state['officeFileModal'] = status;
        state['officeFileAction'] = action;
        if(status === false){
            state['checked'] = [];
            state['downloadFile'] = false;
            state['file'] = null;
        }
        this.setState(state)
    }
    onManageVersions(versionsModal = false){
        this.setState({versionsModal: versionsModal}, () => {
            if(!versionsModal){
                this.loadFiles();
            }
        });
    }
    handleLeftMenuClick(e, file){
        const x = e.clientX;
        const y = e.clientY;
        showMenu({
            position: { x, y },
            id: "file_dropdown_menu",
            data: file
        });
    }
    onContextMenuShow(e){
        const { checked } = this.state;
        if(checked.length > 1){
            return;
        }

        const file = e.detail.data;
        this.setState({
            sharedWith: (file ? file.sharedWith : null),
            currentFile: (file ? file : null),
        }, () => {
            this.handleToggle(file, true);
        });
    }
    getCheckedFiles(){
        let { response, checked, recentFiles } = this.state;
        if(checked.length <= 0){
            return [];
        }

        if(response !== null && recentFiles !== null){
            response = [...response, ...recentFiles];

            response = response.filter((obj, index, self) => 
                self.findIndex(o => o.id === obj.id) === index
            );
        }

        let files = [];
        response && response.map((file) => {
            if(checked.indexOf(file.id) !== -1){
                files.push(file);
            }
            return null;
        });
        return files;
    }
    onCopyMyDocModal(modal = true){
        const checkedFiles = this.getCheckedFiles();

        this.store.dispatch({ type: 'UPDATE_STATE', state: {
            copyFilesState: {
                copyMyDocModal: modal, 
                files: checkedFiles, 
                path: this.state.path
            }
        }});        
    }
    onCopyModal(modal = true){
        this.setState({
            copyFilesModal: modal,
            errorMessage: null
        });
    }
    onCopyModalSuccess(newPath){
        const { shareFileId } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            copyingFilesModal: true,
            cancelToken: source,
        });
        const { checked } = this.state;
        const requestData = {
            path: newPath,
            files: checked
        };
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
            requestData['sharedSection'] = false;
        }
        Api.copyFiles(requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err.error === true){
                this.setState({
                    errorMessage: err.message,
                    copyingFilesModal: false,
                    cancelToken: null
                });
            }
            console.log(err);
        });
    }
    onMoveModal(modal = true){
        this.setState({
            moveFilesModal: modal,
            errorMessage: null
        });
    }
    onMoveModalSuccess(newPath){
        const { shareFileId } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            movingFilesModal: true,
            cancelToken: source,
        });
        const { checked } = this.state;
        const requestData = {
            path: newPath,
            files: checked
        };
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
            requestData['sharedSection'] = false;
        }
        Api.moveFiles(requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err.error === true){
                this.setState({
                    errorMessage: err.message,
                    movingFilesModal: false,
                    cancelToken: null
                });
            }
            console.log(err);
        });
    }
    onRenameModal(modal = true){
        this.setState({
            renameFileModal: modal,
            errorMessage: null
        });
    }
    onRenameModalSuccess(newFileName){
        const { shareFileId } = this.state;
        const checkedFile = this.getCheckedFile();
        if(checkedFile === null){
            return;
        }
        const source = axios.CancelToken.source();
        this.setState({
            renamingFileModal: true,
            cancelToken: source,
        });
        const requestData = {
            name: newFileName,
        };
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
        }
        Api.renameFile(checkedFile.id, requestData, source).then(data => {
            this.loadFiles();
        }).catch(err => {
            if(err && err.duplicate === true){
                this.setState({cancelToken: null, errorMessage: err.message, renamingFileModal: false});
            }
            console.log(err);
        });
    }
    getCheckedFile(checked = null){
        let { response, recentFiles } = this.state;

        if(checked === null){
            checked = this.state.checked;
        }
        if(checked.length <= 0){
            return null;
        }
        if(response !== null && recentFiles !== null){
            response = [...response, ...recentFiles];

            response = response.filter((obj, index, self) => 
                self.findIndex(o => o.id === obj.id) === index
            );
        }

        let currentFile = null;
        response && response.map((file) => {
            if(currentFile !== null){
                return null;
            }
            if(checked.indexOf(file.id) !== -1){
                currentFile = file;
            }
            return null;
        });
        return currentFile;
    }
    isModificationAllowed(){
        const { path } = this.state;
        
        if(path.indexOf("/My Docs") !== -1){
            return true;
        }
        if(path === "/" || path === "/Email" || path.indexOf("/Email/Web") === 0 || path.indexOf("/Email/Outlook") === 0 || path.indexOf("/My Docs") === 0 || path.indexOf("/Mobile") === 0){
            return false;
        }
        return true;
    }
    onNewDocMenuSuccess(extension){
        this.setState({
            docMenuEl: null,
            newFileModal: true,
            newFileExtension: extension
        });
    }
    onNewFileModal(status = false){
        this.setState({
            docMenuEl: null,
            newFileModal: status,
            newFileExtension: null,
            uploadMenuEl: null,
        });
    }
    onNewFileModalSuccess(fileName){
        const { shareFileId } = this.state;
        const { newFileExtension } = this.state;
        const source = axios.CancelToken.source();
        this.setState({
            creatingFile: true,
            cancelToken: source,
        });

        fileName = (fileName+"."+newFileExtension);
        const requestData = {
            fileName: fileName,
            path: this.state.path
        }
        if(shareFileId !== ''){
            requestData['sharedFileId'] = shareFileId;
            requestData['sharedSection'] = false;
        }
        Api.addNewFile(requestData, source).then(data => {
            this.editOfficeDoc(data, true);
            this.setState({
                docMenuEl: null,
                newFileModal: false,
                newFileExtension: null,
                creatingFile: false,
                newFileError: false,
                newFileErrorMessage: null,
                createSnackbarOpen: true,
                createSnackbarName: fileName,
                createSnackbarPath: this.getLastPart(this.state.path),
                createSnackbarType: 'file',
            }, () => {
                this.loadFiles();
            });
        }).catch(err => {
            console.log(err);
        });
    }
    onUploadMenu(event){
        this.setState({
            uploadMenuEl: event.currentTarget
        });
    }
    onNewOfficeDoc(event){
        this.setState({
            docMenuEl: event.currentTarget
        });
    }
    renderUploadMenu(){
        const { uploadMenuEl } = this.state;
        const { classes } = this.props;
        const { user } = this.store.getState();
        let showUpgradeModal = Boolean(uploadMenuEl) && user.account_type === 5;
        return (
            <Menu
                id="upload-menu"
                anchorEl={uploadMenuEl}
                keepMounted
                open={Boolean(uploadMenuEl)}
                onClose={() => this.onNewFileModal()}
                className={classes.createMenu}
                PaperProps={{
                    style: {
                      marginTop: '80px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onUploadModal(true, 'file')} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_1017_4426)">
                            <path opacity="0.4" d="M0 2.25C0 1.00898 1.00898 0 2.25 0H7.875V4.5C7.875 5.12227 8.37773 5.625 9 5.625H13.5V15.75C13.5 16.991 12.491 18 11.25 18H2.25C1.00898 18 0 16.991 0 15.75V2.25ZM3.375 10.6875C3.375 10.902 3.45586 11.1199 3.62109 11.2852C3.95156 11.6156 4.48594 11.6156 4.81289 11.2852L5.90273 10.1953L5.90625 13.7812C5.90625 14.2488 6.28242 14.625 6.75 14.625C7.21758 14.625 7.59375 14.2488 7.59375 13.7812V10.1918L8.68359 11.2816C9.01406 11.6121 9.54844 11.6121 9.87539 11.2816C10.2023 10.9512 10.2059 10.4168 9.87539 10.0898L7.34414 7.55859C7.01367 7.22813 6.4793 7.22813 6.15234 7.55859L3.62109 10.0898C3.45586 10.2551 3.375 10.4695 3.375 10.6875Z" fill="#556DC2"/>
                            <path d="M13.4999 5.625H8.99986C8.37759 5.625 7.87486 5.12227 7.87486 4.5V0L13.4999 5.625ZM7.59361 13.7812C7.59361 14.2488 7.21743 14.625 6.74986 14.625C6.28228 14.625 5.90611 14.2488 5.90611 13.7812V10.1918L4.81626 11.2816C4.48579 11.6121 3.95142 11.6121 3.62446 11.2816C3.29751 10.9512 3.294 10.4168 3.62446 10.0898L6.15571 7.55859C6.48618 7.22813 7.02056 7.22813 7.34751 7.55859L9.87876 10.0898C10.2092 10.4203 10.2092 10.9547 9.87876 11.2816C9.54829 11.6086 9.01392 11.6121 8.68696 11.2816L7.59712 10.1918L7.59361 13.7812Z" fill="#556DC2"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1017_4426">
                            <rect width="13.5" height="18" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </Button>
                    Upload File
                </MuiMenuItem>
                <MuiMenuItem onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onUploadModal(true, 'folder')} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.4" d="M0 3.375V14.625C0 15.866 1.00898 16.875 2.25 16.875H15.75C16.991 16.875 18 15.866 18 14.625V5.625C18 4.38398 16.991 3.375 15.75 3.375H10.125C9.76992 3.375 9.43594 3.20977 9.225 2.925L8.55 2.025C8.12461 1.45898 7.45664 1.125 6.75 1.125H2.25C1.00898 1.125 0 2.13398 0 3.375ZM5.625 9.5625C5.625 9.34805 5.70586 9.13008 5.87109 8.96484L8.40234 6.43359C8.56758 6.26836 8.78203 6.1875 9 6.1875C9.21797 6.1875 9.43242 6.26836 9.59766 6.43359L12.1289 8.96484C12.2941 9.13008 12.375 9.34453 12.375 9.5625C12.375 9.78047 12.2941 9.99492 12.1289 10.1602C11.7984 10.4906 11.2641 10.4906 10.9371 10.1602L9.84727 9.07031L9.84375 12.6562C9.84375 13.1238 9.46758 13.5 9 13.5C8.53242 13.5 8.15625 13.1238 8.15625 12.6562V9.0668L7.06641 10.1566C6.73594 10.4871 6.20156 10.4871 5.87461 10.1566C5.70937 9.99141 5.62852 9.77695 5.62852 9.55898L5.625 9.5625Z" fill="#FAAF42"/>
                            <path d="M8.9998 13.5C9.46738 13.5 9.84355 13.1239 9.84355 12.6563V9.06685L10.9334 10.1567C11.2639 10.4872 11.7982 10.4872 12.1252 10.1567C12.4521 9.82622 12.4557 9.29185 12.1252 8.96489L9.59395 6.43364C9.26348 6.10317 8.7291 6.10317 8.40215 6.43364L5.8709 8.96489C5.54043 9.29536 5.54043 9.82974 5.8709 10.1567C6.20137 10.4836 6.73574 10.4872 7.0627 10.1567L8.15254 9.06685L8.15605 12.6563C8.15605 13.1239 8.53223 13.5 8.9998 13.5Z" fill="#FAAF42"/>
                        </svg>
                    </Button>
                    Upload Folder
                </MuiMenuItem>
            </Menu>
        )
    }
    renderCreateMenu(){
        const { docMenuEl } = this.state;
        const { classes } = this.props;
        const { user } = this.store.getState();
        let showUpgradeModal = Boolean(docMenuEl) && user.account_type === 5;
        return (
            <Menu
                id="new-doc-menu"
                anchorEl={docMenuEl}
                keepMounted
                open={Boolean(docMenuEl)}
                onClose={() => this.onNewFileModal()}
                className={classes.createMenu}
                PaperProps={{
                    style: {
                      marginTop: '80px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => this.onNewFolderModal(true)} className='folder-menu'>
                    <Button justIcon color="transparent" className={classes.fileIcon}>
                        { helper.getFolderIcon() }
                    </Button>
                    New Folder
                </MuiMenuItem>
                {
                    helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') ?
                        [
                            <MuiMenuItem key="new-doc-word" onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onNewDocMenuSuccess("docx")} className='word-menu'>
                                {helper.getFileIcon({extension: "docx"}, classes)}
                                Word Document
                            </MuiMenuItem>,
                            <MuiMenuItem key="new-doc-excel" onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onNewDocMenuSuccess("xlsx")} className='excel-menu'>
                                {helper.getFileIcon({extension: "xlsx"}, classes)}
                                Excel Workbook
                            </MuiMenuItem>,
                            <MuiMenuItem key="new-doc-powerpoint" onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onNewDocMenuSuccess("pptx")} className='powerpoint-menu'>
                                {helper.getFileIcon({extension: "pptx"}, classes)}
                                Powerpoint Presentation
                            </MuiMenuItem>
                        ]
                    :
                        null
                }
            </Menu>
        )
    }
    onFileActionMenu(event, status = true){
        let target = null;
        if(status){
            target = event.currentTarget
        }
        this.setState({
            fileActionsMenuEl: target
        })
    }
    renderFileActionsMenu(){
        const { fileActionsMenuEl } = this.state;
        const { classes } = this.props;
        return (
            <Menu
                id="new-doc-menu"
                anchorEl={fileActionsMenuEl}
                keepMounted
                open={Boolean(fileActionsMenuEl)}
                onClose={(e) => this.onFileActionMenu(e, false)}
                className={classes.fileActionsDropdown}
                PaperProps={{
                    style: {
                      marginTop: '45px',
                    },
                }}
            >
                <MuiMenuItem onClick={() => this.deleteSelected()} className='folder-menu'>
                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.74308 1.125H10.2531C10.4618 1.125 10.6554 1.22344 10.7692 1.38867L11.3498 2.25H5.65022L6.2308 1.38867C6.34085 1.22344 6.53817 1.125 6.74688 1.125H6.74308ZM12.7842 2.25L11.8013 0.794531C11.4674 0.298828 10.883 0 10.2569 0H6.74308C6.11696 0 5.53259 0.298828 5.19866 0.794531L4.21585 2.25H2.43237H1.21429H0.607143C0.273214 2.25 0 2.50312 0 2.8125C0 3.12188 0.273214 3.375 0.607143 3.375H1.30156L2.2692 15.9117C2.35647 17.0895 3.41518 18 4.69018 18H12.3098C13.5848 18 14.6397 17.0895 14.7308 15.9117L15.6984 3.375H16.3929C16.7268 3.375 17 3.12188 17 2.8125C17 2.50312 16.7268 2.25 16.3929 2.25H15.7857H14.5676H12.7842ZM14.4842 3.375L13.5203 15.8309C13.4748 16.418 12.9473 16.875 12.3098 16.875H4.69018C4.05268 16.875 3.52522 16.418 3.47969 15.8309L2.51964 3.375H14.4804H14.4842Z"/>
                    </svg>
                    Delete
                </MuiMenuItem>
                <MuiMenuItem onClick={() => this.onDownloadModal(true)} className='folder-menu'>
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z"/>
                    </svg>
                    Download
                </MuiMenuItem>
            </Menu>
        )
    }
    getRecentFilesData(){
        const { classes } = this.props;
        let { recentFiles } = this.state;

        if(recentFiles === null){
            return [];
        }
        let tableData = [];
        
        recentFiles.map((file, key) => {
            let fileData =  (
                <div className={classes.gridDataItem} key={key}>
                    <ContextMenuTrigger id="file_dropdown_menu" collect={() => {return file}}>
                        {this.getFileNameGrid(file)}
                    </ContextMenuTrigger>
                </div>
            );

            tableData.push(fileData);
            return null;
        });

        return tableData;
    }
    getGridTableData(){
        const { classes } = this.props;
        let { response } = this.state;

        if(response === null){
            return [];
        }
        let tableData = [];

        response && response.map((file, key) => {
            let fileData =  (
                <div className={classes.gridDataItem} key={key}>
                    <ContextMenuTrigger id="file_dropdown_menu" collect={() => {return file}}>
                        {this.getFileNameGrid(file)}
                    </ContextMenuTrigger>
                </div>
            );

            tableData.push(fileData);
            return null;
        });

        return tableData;
    }
    onChangeLayout(type){
        this.setState({
            layoutType: type
        })
    }
    getHeading(){
        const { path } = this.state;
        const heading = "Email Transfers";
        if(path === "/"){
            return heading;
        }
        if(path.indexOf("/My Docs") !== -1){
            return "My Docs";
        }
        if(path.indexOf("/OneDrive") !== -1){
            return "One Drive";
        }
        if(path.indexOf("/Email/Web") !== -1){
            return "Web Transfers";
        }
        if(path.indexOf("/Email/Outlook") !== -1){
            return "Outlook Transfers";
        }
        return heading;
    }
    onTabChange(urlTab){
        localStorage.removeItem('drive_id');

        let stateObj = {
            breadcrumbData: []
        };
        let url = "";
        if(urlTab === '0'){
            stateObj['activeTab'] = 0;
            url = "/user/home?dir=/My Docs";
        }else if(urlTab === '1'){
            stateObj['activeTab'] = 1;
            url = "/user/home?dir=/OneDrive";
        }else if(urlTab === '2'){
            stateObj['activeTab'] = 2;
            url = "/user/home?dir=/Sharepoint";
        }else if(urlTab === '3'){
            stateObj['activeTab'] = 3;
            url = "/user/home?dir=/GoogleDrive";
        }

        this.setState(stateObj);
        this.history.push(url);
    }
    onTrasnferTabChange(urlTab){
        if(urlTab === '0'){
            this.setState({transferActiveTab:0})
            this.history.push("/user/home?dir=/Email");
        }else if(urlTab === '1'){
            this.setState({transferActiveTab:1})
            this.history.push("/user/home?dir=/Email/Web");
        }else if(urlTab === '2'){
            this.setState({transferActiveTab:2})
            this.history.push("/user/home?dir=/Email/Outlook");
        }
    }
    onNewEditAccountModal(status = false, type = '') {
        this.setState({
            newEditAccountModal: status,
            editAccountType: type,
        });
    }
    onSharepointAccountModal(status = false, submit = false){
        this.setState({
            sharepointAccountModal: status,
        });
    }
    toggleRecentFiles(){
        this.setState({
            recentFilesOpen: !this.state.recentFilesOpen
        })
    }
    getSliderSettings(){
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 7,
            slidesToScroll: 7,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                    }
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                }
            ]
        };

        return settings;
    }
    canEditDocument(){
        const modificationAllowed = this.isModificationAllowed();
        if(!modificationAllowed){
            return false;
        }
        const checkedFile = this.getCheckedFile();
        return helper.canEditDocument(checkedFile);
    }
    onUpgradeModalClose(){
        this.setState({
            uploadFileModal: false,
            newFolderModal: false,
            newFolderModalOneDrive : false,
            creatingFolder: false,
            copyFilesModal: false,
            copyMyDocModal: false,
            copyingFilesModal: false,
            copyingMyDocsFilesModal: false,
            moveFilesModal: false,
            movingFilesModal: false,
            renameFileModal: false,
            renamingFileModal: false,
            docMenuEl: null,
            uploadMenuEl: null,
            upgradeModal: false
        });
    }
    onUpgradeModalSuccess(){
        this.history.push("/user/plans");
    }
    renderConfirmationModal(open = true){
        this.setState({
            upgradeModal: open
        })
    }
    onSignDocument(status = false){
        this.setState({
            docusignModal: status
        });
    }
    onDocusignConnectCallback(){
        const source = axios.CancelToken.source();
        this.setState({cancelToken: source, loading: true});

        const requestData = {
            code: helper.getParam("code"),
            state: helper.getParam("state")
        }

        Api.authorizeDocusign(requestData, source).then(data => {
            history.push("/user/home?dir=%2FMy%20Docs");
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.body));
            let newUser = Api.prepareMemberObject(data.body);
            this.store.dispatch({type: "UPDATE_STATE",state: {user: newUser}});
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({cancelToken: null, loading: false});
            }
            this.history.push("/user/home?dir=%2FMy%20Docs");
        });
    }
    onDocusignConnect(type){
        let url = Config.getDocusignSignupUrl();
        if(type === "login"){
            url = Config.getDocusignLoginUrl();
        }
        let state = this.state;
        state.cancelToken = null;
        if(state.currentFile !== null){
            delete state.currentFile.target;
        }
        localStorage.setItem("sendlinx_home_state", JSON.stringify(state));
        window.location.href = url;
    }
    onDocusignSuccess(data){
        this.setState({
            docusignModal: false
        });
        window.open(data.prepareUrl, "_blank");
    }
    onAdobeSignDocument(status = false){
        this.setState({
            adobesignModal: status
        });
    }
    onAdobesignConnectCallback(){
        const source = axios.CancelToken.source();
        this.setState({cancelToken: source, loading: true});

        const requestData = {
            code: helper.getParam("code"),
            state: helper.getParam("state")
        }

        Api.authorizeAdobesign(requestData, source).then(data => {
            history.push("/user/home?dir=%2FMy%20Docs");
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.body));
            let newUser = Api.prepareMemberObject(data.body);
            this.store.dispatch({type: "UPDATE_STATE",state: {user: newUser}});
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({cancelToken: null, loading: false});
            }
            this.history.push("/user/home?dir=%2FMy%20Docs");
        });
    }
    onAdobesignConnect(type, authState){
        let url = Config.getAdobesignSignupUrl(authState);
        if(type === "login"){
            url = Config.getAdobesignLoginUrl(authState);
        }
        let state = this.state;
        state.cancelToken = null;
        if(state.currentFile !== null){
            delete state.currentFile.target;
        }
        localStorage.setItem("sendlinx_home_state", JSON.stringify(state));
        window.location.href = url;
    }
    onAdobesignSuccess(data){
        this.setState({
            adobesignModal: false
        });
        // window.open(data.prepareUrl, "_blank");
    }
    closeDeleteSnackbar(){
        this.setState({
            deleteSnackbarOpen: false,
            deleteFilesCount: 0
        });
    }
    closeCreateSnackbar(){
        this.setState({
            createSnackbarOpen: false,
            createSnackbarName: null,
            createSnackbarPath: null,
            createSnackbarType: null,
        });
    }
    getEmailTabContent(){
        const { classes } = this.props;

        return (
            <GridItem>
                <div className={classes.textContainer}>
                    <h5>Email Transfers: Attachments Overview</h5>
                    <p>In this section, users can easily view and manage the attachments associated with their email communications. Whether the email was sent via the <span>Send Option</span> in the Portal Site or through an external email client like <span>Microsoft Outlook</span>, this section will consolidate all related attachments for quick access and reference.</p>
                    <p>Key Features:</p>
                    <ul>
                        <li><p><span>Unified View:</span> Displays attachments from both the Portal Site's “Send” Option and external email clients (like Outlook), providing a centralized location for all files shared through email services.</p></li>
                        <li><p><span>Organized List:</span> Attachments will be listed with details such as file name, date, size, recipients and related link(s).</p></li>
                        <li><p><span>Download: </span> Users can easily download the attachments directly from this interface.</p></li>
                        <li><p><span>Search & Filter:</span> Options to search by file type, name, or date for faster navigation, making it easy to locate specific attachments.</p></li>
                        <li><p><span>Delete or Re-send Options:</span> In certain cases, users may have the ability to delete an attachment or re-send it to recipients directly from this section.</p></li>
                    </ul>
                    <p>This streamlined feature ensures users can quickly manage and retrieve attachments related to their email communications, regardless of how the message was sent.</p>
                </div>
            </GridItem>
        )
    }
    getFilesContent(files){
        const { classes } = this.props;
        const { loading, loadingMore, page, totalPages, path, searchFormData, backPath, showUpgradeModal,
            layoutType, checked, activeTab, loadingRecentFiles, recentFiles, recentFilesOpen, transferActiveTab } = this.state; 

        const breadcrumbs = this.getBreadCrumbs();
        // const breadcrumbsonedrive = this.getBreadCrumbsOneDrive();
        const tableData = this.getTableData();
        const modificationAllowed = this.isModificationAllowed();
        const { user } = this.store.getState();
        let isSharePoint = false;
        let isOneDrive = false;
        let isGoogleDrive = false;
        let isMyDocsPage = false;
        if(path === "/Sharepoint" || path.includes("/Sharepoint")){
            isSharePoint = true;
        }else if(path === "/OneDrive" || path.includes("/OneDrive")){
            isOneDrive = true;
        }else if(path === "/GoogleDrive" || path.includes("/GoogleDrive")){
            isGoogleDrive = true;
        }

        if(path.indexOf("/My Docs") !== -1 || isOneDrive || isSharePoint || isGoogleDrive){
            isMyDocsPage = true;
        }

        let oneDriveConnected = localStorage.getItem("one_drive_connected");
        let sharePointConnected = localStorage.getItem("sharepoint_connected");
        let googleDriveConnected = localStorage.getItem("google_drive_connected");

        let content = (
            <div className={classes.content+" "+classes.flexPageContent}>
                <div className={classes.controls}>
                    <GridItem className={classes.controlsTabs}>
                        <GridContainer className={classes.alignItems}>
                            <GridItem xs={12} sm={isMyDocsPage ? 12 : 6} md={8}>
                                {
                                    isMyDocsPage ?
                                        <div className='sd-custom-tabs'>
                                            <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                                                <span>My Docs</span>
                                            </div>
                                            {
                                                helper.isExtensionAllowed(user, 'one_drive') && helper.isExtensionEnable(user, 'one_drive') ?
                                                    <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')}>
                                                        {
                                                            oneDriveConnected ?
                                                                <>
                                                                    <span onClick={() => this.onTabChange("1")}>One Drive</span>
                                                                    <Button justIcon onClick={() => this.onNewEditAccountModal(true, 'one_drive')} color="transparent" title="edit">
                                                                        <EditIcon />
                                                                    </Button>
                                                                </>
                                                            :
                                                                <>
                                                                    <span onClick={() => this.loginWith()}>One Drive</span>
                                                                    <Button justIcon onClick={() => this.loginWith()} color="transparent" title="Connect">
                                                                        <CloudOffIcon />
                                                                    </Button>
                                                                </>
                                                        }
                                                    </div>
                                                :
                                                    null
                                            }
                                            {
                                                helper.isExtensionAllowed(user, 'sharepoint') && helper.isExtensionEnable(user, 'sharepoint') ?
                                                    <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')}>
                                                        {
                                                            sharePointConnected ?
                                                                <>
                                                                    <span onClick={() => this.onTabChange("2")}>Sharepoint</span>
                                                                    <Button justIcon onClick={() => this.onSharepointAccountModal(true)} color="transparent" title="edit">
                                                                        <EditIcon />
                                                                    </Button>
                                                                </>
                                                            :
                                                                <>
                                                                    <span onClick={() => this.loginWith(true)}>Sharepoint</span>
                                                                    <Button justIcon onClick={() => this.loginWith(true)} color="transparent" title="Connect">
                                                                        <CloudOffIcon />
                                                                    </Button>
                                                                </>
                                                        }
                                                    </div>
                                                :
                                                    null
                                            }
                                            {
                                                helper.isExtensionAllowed(user, 'google_drive') && helper.isExtensionEnable(user, 'google_drive') ?
                                                    <div className={'sd-custom-tab '+(activeTab === 3 ? 'active': '')}>
                                                        {
                                                            googleDriveConnected ?
                                                                <>
                                                                    <span onClick={() => this.onTabChange("3")}>Google Drive</span>
                                                                    <Button justIcon onClick={() => this.onNewEditAccountModal(true, 'google_drive')} color="transparent" title="edit">
                                                                        <EditIcon />
                                                                    </Button>
                                                                </>
                                                            :
                                                                <>
                                                                    <span onClick={() => this.loginWithGoogle()}>Google Drive</span>
                                                                    <Button justIcon onClick={() => this.loginWithGoogle()} color="transparent" title="Connect">
                                                                        <CloudOffIcon />
                                                                    </Button>
                                                                </>
                                                        }
                                                    </div>
                                                :
                                                    null
                                            }
                                        </div>
                                    :
                                        <div className='sd-custom-tabs'>
                                            <div className={'sd-custom-tab '+(transferActiveTab === 0 ? 'active': '')} onClick={() => this.onTrasnferTabChange("0")}>
                                                <span>Email Transfers</span>
                                            </div>
                                            <div className={'sd-custom-tab '+(transferActiveTab === 1 ? 'active': '')} onClick={() => this.onTrasnferTabChange("1")}>
                                                <span>Web</span>
                                            </div>
                                            <div className={'sd-custom-tab '+(transferActiveTab === 2 ? 'active': '')} onClick={() => this.onTrasnferTabChange("2")}>
                                                <span>Outlook</span>
                                            </div>
                                        </div>
                                }
                            </GridItem>
                            {
                                path === "/Email" ? 
                                    <></>   
                                :
                                    <GridItem xs={12} sm={isMyDocsPage ? 12 : 6} md={4}>                                
                                        <SearchInput 
                                            searchFormData={searchFormData} 
                                            onSuccess={(searchData) => this.onSearchInputSuccess(searchData)} 
                                            clearSearch={() => this.clearSearch()} 
                                            history={this.history} 
                                            store={this.store} 
                                            inputProps={{
                                                placeholder: "Search Files & Folders"
                                            }}
                                        />
                                    </GridItem>
                            }
                        </GridContainer>
                    </GridItem>
                    <GridItem>
                        {
                            isOneDrive || isSharePoint || isGoogleDrive ?
                                <h4 className='tabs-info'>
                                    {
                                        isOneDrive ?
                                            <p><span>OneDrive: </span>{localStorage.getItem("one_drive_email")}</p>
                                        : isSharePoint ?
                                            <>
                                                <p><span>Sharepoint: </span>{localStorage.getItem("sharepoint_email")}</p>
                                                <p><span>Site: </span><span className='link-color'>{localStorage.getItem("sharepoint_site_name")}</span></p>
                                            </>
                                        : isGoogleDrive ?
                                            <p><span>Google Drive: </span>{localStorage.getItem("google_drive_email")}</p>
                                        : 
                                            null
                                    }
                                </h4>
                            :
                                <></>
                        }
                        <div className={classes.controlButtons+" "+(user.theme === 'standard' ? '': 'light-theme-buttons')}>
                            {
                                isOneDrive || isSharePoint || isGoogleDrive ? 
                                    <>
                                        {
                                            isGoogleDrive ?
                                                <GoogleDrivePicker 
                                                    accessToken={localStorage.getItem("google_drive_token")} 
                                                    loadFiles={(e) => this.loadFiles()}
                                                />
                                            :
                                                <></>
                                        }
                                        <Button color="transparent" disabled={checked.length === 0 ? true : false}
                                            onClick={(e) => {
                                                const enoughSpace = this.checkFileSize();
                                                if (!enoughSpace) {
                                                    console.warn('Not enough space in memory.');
                                                } else {
                                                    this.onCopyMyDocModal(true)
                                                }
                                            }}
                                            title={
                                                isOneDrive ?
                                                    "Copy to /My Docs/"+user.extensions.one_drive.path
                                                : isSharePoint ?
                                                    "Copy to /My Docs/"+user.extensions.sharepoint.path
                                                : isGoogleDrive ?
                                                    "Copy to /My Docs/"+user.extensions.google_drive.path
                                                :
                                                    ""
                                            }
                                        >
                                            <FileCopyIcon className={classes.icons} />
                                            Copy To My Docs
                                        </Button>
                                    </>  
                                :
                                    modificationAllowed ?
                                        <>
                                            <Button color="transparent" title="Upload" aria-controls="upload-menu" aria-haspopup="true" onClick={() => showUpgradeModal ? this.renderConfirmationModal() : this.onUploadModal(true, 'file')}>
                                                <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.5549 0.238696C11.2504 -0.0761475 10.7496 -0.0761475 10.4451 0.238696L4.15937 6.7387C3.85491 7.05354 3.85491 7.57151 4.15937 7.88635C4.46384 8.2012 4.96473 8.2012 5.2692 7.88635L10.2143 2.77268V17.0625C10.2143 17.5094 10.5679 17.875 11 17.875C11.4321 17.875 11.7857 17.5094 11.7857 17.0625V2.77268L16.7308 7.88635C17.0353 8.2012 17.5362 8.2012 17.8406 7.88635C18.1451 7.57151 18.1451 7.05354 17.8406 6.7387L11.5549 0.238696ZM1.57143 17.0625C1.57143 16.6157 1.21786 16.25 0.785714 16.25C0.353571 16.25 0 16.6157 0 17.0625V21.9375C0 24.1821 1.75804 26 3.92857 26H18.0714C20.242 26 22 24.1821 22 21.9375V17.0625C22 16.6157 21.6464 16.25 21.2143 16.25C20.7821 16.25 20.4286 16.6157 20.4286 17.0625V21.9375C20.4286 23.2832 19.3728 24.375 18.0714 24.375H3.92857C2.62723 24.375 1.57143 23.2832 1.57143 21.9375V17.0625Z"/>
                                                </svg>
                                                Upload
                                            </Button>
                                            {/* {this.renderUploadMenu()} */}
                                            <Button color="transparent" title="Create" aria-controls="new-doc-menu" aria-haspopup="true" onClick={(event) => this.onNewOfficeDoc(event)}>
                                                <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.7858 3.125C11.7858 2.69531 11.4322 2.34375 11.0001 2.34375C10.5679 2.34375 10.2143 2.69531 10.2143 3.125V11.7188H1.57148C1.13934 11.7188 0.785767 12.0703 0.785767 12.5C0.785767 12.9297 1.13934 13.2812 1.57148 13.2812H10.2143V21.875C10.2143 22.3047 10.5679 22.6562 11.0001 22.6562C11.4322 22.6562 11.7858 22.3047 11.7858 21.875V13.2812H20.4286C20.8608 13.2812 21.2143 12.9297 21.2143 12.5C21.2143 12.0703 20.8608 11.7188 20.4286 11.7188H11.7858V3.125Z"/>
                                                </svg>
                                                Create
                                            </Button>
                                            {this.renderCreateMenu()}                                            
                                        </>
                                    :
                                        <></>
                            }
                        </div>
                    </GridItem>
                </div>
                {
                    path === "/Email" ? 
                        this.getEmailTabContent()
                    :
                        <>
                            {
                                loadingRecentFiles === false && path.indexOf("/My Docs") !== -1 && recentFiles !== null && recentFiles.length > 0 ? 
                                    <GridItem>
                                        <div className={classes.recentFiles}>
                                            <div className='recent-files-title' onClick={() => this.toggleRecentFiles()}>
                                                <h3>Recent Files</h3>
                                                <span>
                                                    {
                                                        recentFilesOpen ?
                                                            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M5.5 7L0.73686 0.25L10.2631 0.25L5.5 7Z" />
                                                            </svg>
                                                        :
                                                            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.25 0.73686L6.5 5.5L0.25 10.2631V0.73686Z" />
                                                            </svg>
                                                    }
                                                </span>
                                            </div>
                                            {
                                                recentFilesOpen && false ?
                                                    <div className={classes.gridTableData}>
                                                        { this.getRecentFilesData() }
                                                    </div>
                                                :
                                                    <></>
                                            }
                                            {
                                                recentFilesOpen ?
                                                    <div className={classes.recentFilesSlider}>
                                                        <Carousel {...this.getSliderSettings()}>
                                                            { this.getRecentFilesData() }
                                                        </Carousel>
                                                    </div>
                                                :
                                                    <></>
                                            }
                                        </div>
                                    </GridItem>
                                :
                                    <></>
                            }
                            <GridItem className={classes.breadcrumbsActionsLayouts}>
                                <div className={classes.breadcrumbs}>
                                    {
                                        loading === false && breadcrumbs.length > 0 ?
                                            <>
                                                {
                                                    breadcrumbs.map((breadCrumb, key) => {
                                                        return (
                                                            <div key={key}>
                                                                {
                                                                    key !== 0 ?
                                                                        <span><ChevronRight /></span>
                                                                    :
                                                                    <></>
                                                                }
                                                                <Link href="/user/home" className={(breadCrumb.value === '/' ? 'breadcrumb-home' : '')} onClick={(e) => {e.preventDefault(); this.loadFiles(false, null, breadCrumb.value);}}>
                                                                    {breadCrumb.label}
                                                                </Link>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </>
                                        :
                                            <></>
                                    }
                                </div>
                                <div className={"file-actions-layouts"}>
                                {
                                    isOneDrive || isSharePoint || isGoogleDrive || checked.length <= 0 ? 
                                        <></>
                                    :
                                        <div className={classes.fileActionsMenu}>
                                            {
                                                Config.isLimitedAccess() === false ?
                                                    <>
                                                        {
                                                            path !== "/Email" && this.isRelatedLinkEnable() ?
                                                                <Button className={"related-link-button"} color="transparent" onClick={() => this.onRelatedLinks()} title="Related Links">
                                                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clipPath="url(#clip0_470_28)">
                                                                            <path d="M0 3.5C0 2.67266 0.672656 2 1.5 2H5.25V5C5.25 5.41484 5.58516 5.75 6 5.75H9V12.5C9 13.3273 8.32734 14 7.5 14H1.5C0.672656 14 0 13.3273 0 12.5V3.5ZM9 5H6V2L9 5Z" fill="#556DC2"/>
                                                                        </g>
                                                                        <path d="M18 2.86008C18 4.43829 16.7153 5.71658 15.1292 5.71658C14.3074 5.71658 13.5645 5.3738 13.0442 4.82392L7.62547 7.51975C7.65418 7.67686 7.66494 7.83754 7.66494 8.00179C7.66494 8.16603 7.65059 8.32671 7.62547 8.48382L13.0442 11.1796C13.5681 10.6298 14.3074 10.287 15.1292 10.287C16.7153 10.287 18 11.5653 18 13.1435C18 14.7217 16.7153 16 15.1292 16C13.543 16 12.2583 14.7217 12.2583 13.1435C12.2583 12.7971 12.3193 12.4651 12.4341 12.1544L7.8462 9.69126C7.00015 9.55501 8.26927 9.69126 7.00015 9.55501C7.00005 10.4861 7.00015 10.3216 7.00015 8.74339C7.00015 7.16517 6.9999 8.74339 7.00004 7.94854C7.00004 6.75626 6.99699 6.60634 7.62552 6.40537L12.4341 3.84557C12.3193 3.5385 12.2583 3.20643 12.2583 2.85651C12.2583 1.27829 13.543 0 15.1292 0C16.7153 0 18 1.27829 18 2.85651V2.86008ZM16.8517 2.86008C16.8517 2.40552 16.6702 1.96958 16.3471 1.64816C16.0241 1.32674 15.586 1.14617 15.1292 1.14617C14.6723 1.14617 14.2342 1.32674 13.9112 1.64816C13.5881 1.96958 13.4066 2.40552 13.4066 2.86008C13.4066 3.31463 13.5881 3.75057 13.9112 4.07199C14.2342 4.39341 14.6723 4.57398 15.1292 4.57398C15.586 4.57398 16.0241 4.39341 16.3471 4.07199C16.6702 3.75057 16.8517 3.31463 16.8517 2.86008ZM15.1292 14.8574C15.3554 14.8574 15.5793 14.8131 15.7883 14.7269C15.9973 14.6408 16.1872 14.5146 16.3471 14.3554C16.5071 14.1963 16.634 14.0073 16.7205 13.7994C16.8071 13.5914 16.8517 13.3686 16.8517 13.1435C16.8517 12.9184 16.8071 12.6956 16.7205 12.4876C16.634 12.2797 16.5071 12.0907 16.3471 11.9316C16.1872 11.7724 15.9973 11.6462 15.7883 11.5601C15.5793 11.4739 15.3554 11.4296 15.1292 11.4296C14.9029 11.4296 14.679 11.4739 14.47 11.5601C14.261 11.6462 14.0711 11.7724 13.9112 11.9316C13.7512 12.0907 13.6243 12.2797 13.5378 12.4876C13.4512 12.6956 13.4066 12.9184 13.4066 13.1435C13.4066 13.3686 13.4512 13.5914 13.5378 13.7994C13.6243 14.0073 13.7512 14.1963 13.9112 14.3554C14.0711 14.5146 14.261 14.6408 14.47 14.7269C14.679 14.8131 14.9029 14.8574 15.1292 14.8574Z" fill="#556DC2"/>
                                                                        <defs>
                                                                            <clipPath id="clip0_470_28">
                                                                                <rect width="9" height="12" fill="white" transform="translate(0 2)"/>
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    Related Links
                                                                </Button>
                                                            :
                                                                <></>
                                                        }
                                                    </>
                                                :
                                                    <></>
                                            }
                                            <Button className={"delete-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.deleteSelected()} title="Delete">
                                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.74308 1.125H10.2531C10.4618 1.125 10.6554 1.22344 10.7692 1.38867L11.3498 2.25H5.65022L6.2308 1.38867C6.34085 1.22344 6.53817 1.125 6.74688 1.125H6.74308ZM12.7842 2.25L11.8013 0.794531C11.4674 0.298828 10.883 0 10.2569 0H6.74308C6.11696 0 5.53259 0.298828 5.19866 0.794531L4.21585 2.25H2.43237H1.21429H0.607143C0.273214 2.25 0 2.50312 0 2.8125C0 3.12188 0.273214 3.375 0.607143 3.375H1.30156L2.2692 15.9117C2.35647 17.0895 3.41518 18 4.69018 18H12.3098C13.5848 18 14.6397 17.0895 14.7308 15.9117L15.6984 3.375H16.3929C16.7268 3.375 17 3.12188 17 2.8125C17 2.50312 16.7268 2.25 16.3929 2.25H15.7857H14.5676H12.7842ZM14.4842 3.375L13.5203 15.8309C13.4748 16.418 12.9473 16.875 12.3098 16.875H4.69018C4.05268 16.875 3.52522 16.418 3.47969 15.8309L2.51964 3.375H14.4804H14.4842Z" fill="#556DC2"/>
                                                </svg>
                                                Delete
                                            </Button>
                                            <Button className={"download-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.onDownloadModal(true)} title="Download">
                                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z" fill="#556DC2"/>
                                                </svg>
                                                Download
                                            </Button>  
                                            {
                                                Config.isLimitedAccess() === false ?
                                                    <>
                                                        {
                                                            path.trim() !== "/" && (path.indexOf("/Email") === -1) ?
                                                                    <Button className={"newlink-button"} color="transparent" disabled={checked.length <= 0 ? true : false} onClick={() => this.onLinkName(true)} title="New Link">
                                                                        <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M21.3393 10.1999C22.8866 8.64384 22.8866 6.12301 21.3393 4.56695C19.7919 3.01089 17.2853 3.01089 15.7379 4.56695L15.0385 5.27029C14.8467 5.46324 14.8467 5.78068 15.0385 5.97363C15.2304 6.16658 15.5461 6.16658 15.7379 5.97363L16.4373 5.27029C17.5978 4.10324 19.4794 4.10324 20.6399 5.27029C21.8004 6.43734 21.8004 8.32951 20.6399 9.49656L16.7839 13.3712C15.6265 14.5351 13.7481 14.5351 12.5876 13.3712C11.4859 12.2632 11.424 10.4893 12.4421 9.30672L12.6061 9.11688C12.7856 8.90837 12.764 8.59404 12.5566 8.41354C12.3493 8.23304 12.0367 8.25482 11.8572 8.46334L11.6932 8.65317C10.3346 10.231 10.4182 12.5962 11.8851 14.0714C13.4293 15.6243 15.936 15.6243 17.4802 14.0714L21.3393 10.1999ZM4.53525 10.1999C2.98792 11.756 2.98792 14.2768 4.53525 15.8329C6.08258 17.3889 8.58926 17.3889 10.1366 15.8329L10.836 15.1295C11.0279 14.9366 11.0279 14.6191 10.836 14.4262C10.6441 14.2332 10.3285 14.2332 10.1366 14.4262L9.43719 15.1295C8.2767 16.2966 6.39514 16.2966 5.23465 15.1295C4.07415 13.9625 4.07415 12.0703 5.23465 10.9032L9.09059 7.02864C10.248 5.86471 12.1265 5.86471 13.287 7.02864C14.3887 8.13656 14.4505 9.91048 13.4324 11.0931L13.2684 11.2829C13.0889 11.4914 13.1106 11.8058 13.3179 11.9863C13.5252 12.1668 13.8378 12.145 14.0173 11.9365L14.1813 11.7466C15.5399 10.1688 15.4563 7.80356 13.9894 6.32842C12.439 4.76924 9.93544 4.76924 8.38811 6.32219L4.53525 10.1999Z"/>
                                                                            <path d="M4.37019 2.70262C4.37019 2.46152 4.17683 2.26672 3.9375 2.26672C3.69817 2.26672 3.50481 2.46152 3.50481 2.70262V4.66416H1.55769C1.31836 4.66416 1.125 4.85895 1.125 5.10006C1.125 5.34116 1.31836 5.53595 1.55769 5.53595H3.50481V7.49749C3.50481 7.7386 3.69817 7.93339 3.9375 7.93339C4.17683 7.93339 4.37019 7.7386 4.37019 7.49749V5.53595H6.31731C6.55664 5.53595 6.75 5.34116 6.75 5.10006C6.75 4.85895 6.55664 4.66416 6.31731 4.66416H4.37019V2.70262Z"/>
                                                                        </svg>
                                                                        New Link
                                                                    </Button>
                                                            :
                                                                <></>
                                                        }
                                                    </>
                                                :
                                                    <></>
                                            }  
                                            <Button className={"more-button"} color="transparent" disabled={checked.length <= 0 ? true : false} aria-controls="new-doc-menu" aria-haspopup="true" onClick={(event) => this.onFileActionMenu(event)}>
                                                <svg width="20" height="5" viewBox="0 0 20 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19.4062 2.5C19.4062 3.07187 19.1791 3.62032 18.7747 4.0247C18.3703 4.42907 17.8219 4.65625 17.25 4.65625C16.6781 4.65625 16.1297 4.42907 15.7253 4.0247C15.3209 3.62032 15.0938 3.07187 15.0938 2.5C15.0938 1.92813 15.3209 1.37968 15.7253 0.975301C16.1297 0.570925 16.6781 0.34375 17.25 0.34375C17.8219 0.34375 18.3703 0.570925 18.7747 0.975301C19.1791 1.37968 19.4062 1.92813 19.4062 2.5ZM12.2188 2.5C12.2188 2.78316 12.163 3.06355 12.0546 3.32516C11.9463 3.58677 11.7874 3.82447 11.5872 4.0247C11.387 4.22493 11.1493 4.38375 10.8877 4.49212C10.6261 4.60048 10.3457 4.65625 10.0625 4.65625C9.77934 4.65625 9.49895 4.60048 9.23734 4.49212C8.97573 4.38375 8.73803 4.22493 8.5378 4.0247C8.33757 3.82447 8.17875 3.58677 8.07038 3.32516C7.96202 3.06355 7.90625 2.78316 7.90625 2.5C7.90625 2.21684 7.96202 1.93645 8.07038 1.67484C8.17875 1.41323 8.33757 1.17553 8.5378 0.975301C8.73803 0.775074 8.97573 0.616246 9.23734 0.507885C9.49895 0.399523 9.77934 0.34375 10.0625 0.34375C10.3457 0.34375 10.6261 0.399523 10.8877 0.507885C11.1493 0.616246 11.387 0.775074 11.5872 0.975301C11.7874 1.17553 11.9463 1.41323 12.0546 1.67484C12.163 1.93645 12.2188 2.21684 12.2188 2.5ZM2.875 4.65625C2.30313 4.65625 1.75468 4.42907 1.3503 4.0247C0.945926 3.62032 0.71875 3.07187 0.71875 2.5C0.71875 1.92813 0.945926 1.37968 1.3503 0.975301C1.75468 0.570925 2.30313 0.34375 2.875 0.34375C3.44687 0.34375 3.99532 0.570925 4.3997 0.975301C4.80407 1.37968 5.03125 1.92813 5.03125 2.5C5.03125 3.07187 4.80407 3.62032 4.3997 4.0247C3.99532 4.42907 3.44687 4.65625 2.875 4.65625Z"/>
                                                </svg>
                                            </Button>
                                            {this.renderFileActionsMenu()}
                                        </div>
                                }
                                {
                                    loading === false && modificationAllowed ?
                                        <div className={classes.filesLayoutType}>
                                            {
                                                layoutType === 'grid' ? 
                                                    <Button color="transparent" justIcon className={classes.fileIcon} onClick={() => this.onChangeLayout('list')}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                            <path d="M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z" fill="#B3B3BF"/>
                                                        </svg>
                                                    </Button>
                                                :
                                                    <Button color="transparent" justIcon className={classes.fileIcon} onClick={() => this.onChangeLayout('grid')}>
                                                        <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0 3.23438C0 2.2416 0.799107 1.4375 1.78571 1.4375H3.92857C4.91518 1.4375 5.71429 2.2416 5.71429 3.23438V5.39062C5.71429 6.3834 4.91518 7.1875 3.92857 7.1875H1.78571C0.799107 7.1875 0 6.3834 0 5.39062V3.23438ZM0 10.4219C0 9.4291 0.799107 8.625 1.78571 8.625H3.92857C4.91518 8.625 5.71429 9.4291 5.71429 10.4219V12.5781C5.71429 13.5709 4.91518 14.375 3.92857 14.375H1.78571C0.799107 14.375 0 13.5709 0 12.5781V10.4219ZM5.71429 17.6094V19.7656C5.71429 20.7584 4.91518 21.5625 3.92857 21.5625H1.78571C0.799107 21.5625 0 20.7584 0 19.7656V17.6094C0 16.6166 0.799107 15.8125 1.78571 15.8125H3.92857C4.91518 15.8125 5.71429 16.6166 5.71429 17.6094ZM7.14286 3.23438C7.14286 2.2416 7.94196 1.4375 8.92857 1.4375H11.0714C12.058 1.4375 12.8571 2.2416 12.8571 3.23438V5.39062C12.8571 6.3834 12.058 7.1875 11.0714 7.1875H8.92857C7.94196 7.1875 7.14286 6.3834 7.14286 5.39062V3.23438ZM12.8571 10.4219V12.5781C12.8571 13.5709 12.058 14.375 11.0714 14.375H8.92857C7.94196 14.375 7.14286 13.5709 7.14286 12.5781V10.4219C7.14286 9.4291 7.94196 8.625 8.92857 8.625H11.0714C12.058 8.625 12.8571 9.4291 12.8571 10.4219ZM7.14286 17.6094C7.14286 16.6166 7.94196 15.8125 8.92857 15.8125H11.0714C12.058 15.8125 12.8571 16.6166 12.8571 17.6094V19.7656C12.8571 20.7584 12.058 21.5625 11.0714 21.5625H8.92857C7.94196 21.5625 7.14286 20.7584 7.14286 19.7656V17.6094ZM20 3.23438V5.39062C20 6.3834 19.2009 7.1875 18.2143 7.1875H16.0714C15.0848 7.1875 14.2857 6.3834 14.2857 5.39062V3.23438C14.2857 2.2416 15.0848 1.4375 16.0714 1.4375H18.2143C19.2009 1.4375 20 2.2416 20 3.23438ZM14.2857 10.4219C14.2857 9.4291 15.0848 8.625 16.0714 8.625H18.2143C19.2009 8.625 20 9.4291 20 10.4219V12.5781C20 13.5709 19.2009 14.375 18.2143 14.375H16.0714C15.0848 14.375 14.2857 13.5709 14.2857 12.5781V10.4219ZM20 17.6094V19.7656C20 20.7584 19.2009 21.5625 18.2143 21.5625H16.0714C15.0848 21.5625 14.2857 20.7584 14.2857 19.7656V17.6094C14.2857 16.6166 15.0848 15.8125 16.0714 15.8125H18.2143C19.2009 15.8125 20 16.6166 20 17.6094Z" fill="#B3B3BF"/>
                                                        </svg>
                                                    </Button>
                                            }
                                        </div>
                                    :
                                        <></>
                                }
                                </div>
                            </GridItem>
                            <GridItem className={classes.tableGridItem+" "+(layoutType === 'grid' ? '' : 'table-grid')}>
                                <div className={classes.filesContainer}>
                                    <div className={classes.files}>
                                        {
                                            loading ?
                                                <LoaderComponent color="custom" align="center" />
                                            :
                                                null
                                        }
                                        {
                                            layoutType === 'grid' ?
                                                <>
                                                    {
                                                        loading === false && modificationAllowed ? 
                                                            <div className={classes.gridTableData}>
                                                                { this.getGridTableData() }
                                                            </div>
                                                        :
                                                            <></>
                                                    }
                                                </>
                                            :
                                                <ReactTable
                                                    columns={this.getColumns()}
                                                    data={tableData}
                                                    pageSizeOptions={[500]}
                                                    defaultPageSize={50000000000}
                                                    showPaginationTop={false}
                                                    minRows={0}
                                                    showPaginationBottom={false}
                                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable+" "+classes.homePageTable+" "+(backPath.length > 0 ? classes.stickyRow : "")}
                                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                                    getNoDataProps={() => this.getNoDataProps()}
                                                />
                                            
                                        }
                                        <div className={classes.loadMore}>
                                            {
                                                tableData.length > 0 && loadingMore === false && page < totalPages ?
                                                    <Button color="custom" id="contentViewMore" onClick={(e) => this.loadFiles(true)}>
                                                        <RefreshIcon className={classes.icons} />View More
                                                    </Button>
                                                    
                                                :
                                                    loadingMore === true ?
                                                        <LoaderComponent color="custom" align="center" />
                                                    :
                                                    <></>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </>
                }
            </div>
        );
        
        if(path.indexOf("/My Docs") === 0 || path.indexOf("My Docs") === 0){
            return (
                <DragNDrop onDrop={(files) => this.onDrop(files)}>
                    { content }
                </DragNDrop>
            );
        }else{
            return (
                content 
            );
        }
    }
    render() {
        const { classes } = this.props;
        const { deleteFileModal, path, shareFileModal,
            downloadModal, downloadingFiles, newFolderModal, creatingFolder, copyFilesModal, copyingFilesModal,
            moveFilesModal, movingFilesModal, renameFileModal, renamingFileModal, files, errorMessage, checked, sharingFiles,
            advShareModal, sharedWith, currentFile, downloadLink, linkName, sharedWithUsers, shareFileId,
            versionsModal, newLinkUploaded, officeFileModal, officeFileAction, newFileModal, newFileExtension, creatingFile,
            newFileError, newFileErrorMessage, imagePreviewModal, pdfFileModal, noPreviewModal, detailsSection, saving,
            docusignModal, adobesignModal, newEditAccountModal, editAccountType, sharepointAccountModal, upgradeModal, 
            deleteSnackbarOpen, deleteFilesCount, createSnackbarOpen, createSnackbarName, createSnackbarPath, 
            createSnackbarType } = this.state;
        const modificationAllowed = this.isModificationAllowed();
        const { authorized, user } = this.store.getState();
        if(!authorized || user.level_id === 5){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }

        const checkedFiles = this.getCheckedFiles();
        const checkedFile = this.getCheckedFile();
        const canEdit = this.canEditDocument();
        return (
            <div className={classes.main}>
                <div className={classes.container}>
                    {
                        this.getFilesContent(files)
                    }
                </div>
                {
                    advShareModal &&  path.indexOf("/My Docs") !== -1 ?
                        <ShareModal
                            open={advShareModal}
                            onClose={() => this.onAdvShareModal(false)}
                            onSuccess={() => this.onAdvShareModal(false)}
                            files={checkedFiles}
                            store={this.store} 
                            checked={checked}
                            sharedWith={sharedWith}
                            onPermissionsUpdate={this.onPermissionsUpdate}
                        />
                    :
                    <></>
                }
                {
                    shareFileModal ?
                        <NewLinkModal 
                            open={shareFileModal} 
                            saving={sharingFiles} 
                            onClose={() => this.onLinkName(false)} 
                            onSuccess={() => this.onShareModalSuccess()}
                            onLinkName={(name, linkPassword, expire, pdfTracking, requireVerification, permittedEmails) => this.onShareModal(true, name, linkPassword, expire, pdfTracking, requireVerification, permittedEmails)}
                            loadingMessage="Please wait while we prepare your download link. It may take a few minutes depending on the size and number of files."
                            successMessage={ newLinkUploaded === true ? 'Generating Link...' : 'Link Ready for Sharing' }
                            errorMessage={errorMessage}
                            downloadLink={downloadLink}
                            linkName={linkName}
                            store={this.store}
                            linkHash={this.state.linkHash}
                            havePdfFile={this.havePdfFile()}
                            history={this.history}
                            items={this.state.checked.map(fileId => this.getCheckedFile([fileId])).filter(Boolean)}
                            path={typeof(this.state.path) === "string" ? this.state.path : ""}
                        />
                    :
                    <></>
                }
                {
                    downloadModal ?
                        <ProcessingModal 
                            open={downloadModal} 
                            saving={downloadingFiles} 
                            onClose={() => this.onDownloadModal(false)} 
                            onSuccess={() => this.onDownloadModalSuccess()}
                            loadingMessage="Please wait while we prepare your download link. It may take few minutes depending on size and number of file(s)."
                            successMessage="Your file(s) has been processed and your download link is ready."
                            errorMessage={errorMessage}
                            store={this.store} 
                        />
                    :
                    <></>
                }
                {
                    newFolderModal && user.account_type === 5 ?
                        this.renderConfirmationModal()
                    : newFolderModal ?
                        <NewFolderModal
                            open={newFolderModal}
                            saving={creatingFolder}
                            store={this.store} 
                            path={path}
                            onClose={() => this.onNewFolderModal(false)}
                            onSuccess={(folderName) => this.onNewFolderModalSuccess(folderName)}
                            confirmationMessage="Create a Folder"
                        />
                    :
                        <></>
                }
                {
                    newFileModal && user.account_type === 5 ?
                        this.renderConfirmationModal()
                    : newFileModal ?
                        <NewFileModal
                            open={newFileModal}
                            saving={creatingFile}
                            store={this.store} 
                            path={path}
                            extension={newFileExtension}
                            onClose={() => this.onNewFileModal(false)}
                            onSuccess={(fileName) => this.onNewFileModalSuccess(fileName)}
                            confirmationMessage="Create a File"
                            error={newFileError}
                            errorMessage={newFileErrorMessage}
                        />
                    :
                        <></>
                }
                {
                    createSnackbarOpen ?
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            className={classes.snackbar}
                            open={createSnackbarOpen}
                            autoHideDuration={4000}
                            onClose={this.closeCreateSnackbar}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">{'Created '+createSnackbarType+' '+createSnackbarName+' in '+createSnackbarPath}</span>}
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className={classes.close}
                                    onClick={this.closeCreateSnackbar}
                                >
                                    <CloseIcon />
                                </IconButton>
                            ]}
                        />
                    :
                        <></>
                }
                {
                    moveFilesModal ?
                        <MoveFilesModal 
                            open={moveFilesModal} 
                            saving={movingFilesModal} 
                            onClose={() => this.onMoveModal(false)} 
                            onSuccess={(newPath) => this.onMoveModalSuccess(newPath)}
                            path={path}
                            files={checkedFiles}
                            loadingMessage="Please wait while we move your files. It may take few minutes depending on size of the files."
                            successMessage="Move your files to new path."
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    renameFileModal && checkedFile !== null ?
                        <RenameFileModal 
                            open={renameFileModal} 
                            saving={renamingFileModal} 
                            onClose={() => this.onRenameModal(false)} 
                            onSuccess={(newPath) => this.onRenameModalSuccess(newPath)}
                            file={checkedFile}
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    versionsModal ?
                        <FileVersionModal 
                            store={this.store}
                            open={versionsModal} 
                            saving={renamingFileModal} 
                            onClose={() => this.onManageVersions(false)} 
                            file={checkedFile}
                            errorMessage={errorMessage}
                            sharedWith={sharedWithUsers}
                            sharedFileId={shareFileId} 
                            groupNotification={( shareFileId ? "optional" : '')} 
                        />
                    :
                    <></>

                }
                {
                    copyFilesModal ?
                        <CopyFilesModal 
                            open={copyFilesModal} 
                            saving={copyingFilesModal} 
                            onClose={() => this.onCopyModal(false)} 
                            onSuccess={(newPath) => this.onCopyModalSuccess(newPath)}
                            path={path}
                            files={checkedFiles}
                            loadingMessage="Please wait while we copy your files. It may take few minutes depending on size of the files."
                            successMessage="Copy your files to new path."
                            errorMessage={errorMessage}
                        />
                    :
                    <></>
                }
                {
                    officeFileModal && user.account_type === 5 ?
                        this.renderConfirmationModal()
                    :
                    officeFileModal ?
                        <OfficeFileModal 
                            open={officeFileModal} 
                            action={officeFileAction}
                            file={checkedFile}
                            onClose={() => this.onOfficeFileModal(null, false)}
                        />
                    :
                    null
                }
                {
                    imagePreviewModal ?
                        <ImagePreviewModal
                            open={imagePreviewModal}
                            onClose={() => this.onImagePreviewModal(false)}
                            file={checkedFile}
                            onDownload={() => this.onDownloadModal(true)}
                        />
                    :
                    <></>
                }
                {
                    pdfFileModal ?
                        <PdfViewModal 
                            store={this.store}
                            open={pdfFileModal} 
                            file={checkedFile}
                            onClose={() => this.onPdfFileModal(false)}
                            trackPdf={shareFileId !== '' && helper.isExtensionEnable(user, 'pdf_track')}
                            ownerId={user.id}
                        />
                    :
                    null
                }
                {
                    noPreviewModal ?
                        <NoPreviewModal 
                            store={this.store}
                            open={noPreviewModal} 
                            onDownload={() => this.onDownloadModal(true)}
                            onClose={() => this.onNoPreviewModal(false)}
                        />
                    :
                    null
                }
                {
                    detailsSection && checkedFile ?
                        <DetailsSection
                            open={detailsSection}
                            onClose={() => this.onDetailPreviewSection(false)}
                            file={checkedFile}
                            modificationAllowed={modificationAllowed}
                        />
                    :
                        <></>
                }
                {
                    path.indexOf("/My Docs") !== -1 ?
                        <ContextMenu id="file_dropdown_menu" onShow={(e) => this.onContextMenuShow(e)}>
                            {
                                modificationAllowed && helper.hasThumbnail(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('imagePreview', data, collect)}>
                                        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                        </svg>
                                        Preview
                                    </MenuItem>
                                :   
                                    <></>
                            }
                            {
                                modificationAllowed && helper.isPdfDocument(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfPreview', data, collect)}>
                                        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                        </svg>
                                        Preview
                                    </MenuItem>
                                :   
                                    <></>
                            }
                            {
                                helper.isExtensionAllowed(user, 'ms_office') && helper.isExtensionEnable(user, 'ms_office') && helper.isOfficeDocument(checkedFile) ?
                                    <>
                                        <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('view', data, collect)}>
                                            <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                            </svg>
                                            Preview
                                        </MenuItem>
                                        {
                                            canEdit ?
                                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('edit', data, collect)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="1064.000000pt" height="1281.000000pt" viewBox="0 0 1064.000000 1281.000000" preserveAspectRatio="xMidYMid meet">
                                                        <g transform="translate(0.000000,1281.000000) scale(0.100000,-0.100000)" stroke="none">
                                                            <path d="M6800 12775 c-47 -19 -413 -155 -815 -303 -698 -258 -1343 -497 -2770 -1024 -1731 -640 -2121 -784 -2642 -976 l-563 -207 0 -3892 0 -3892 68 30 c37 17 220 97 407 179 378 164 928 405 1370 599 160 70 347 152 417 182 l127 54 3 3070 3 3070 370 86 c204 48 719 168 1145 267 426 100 989 231 1250 292 261 61 743 174 1070 250 327 76 607 141 623 145 l27 7 0 -4531 0 -4531 -27 5 c-16 3 -554 68 -1198 146 -643 77 -1224 147 -1290 155 -2127 257 -4341 522 -4342 520 -2 -2 207 -78 465 -171 257 -92 514 -185 572 -206 58 -21 276 -99 485 -174 209 -75 553 -199 765 -275 212 -76 610 -219 885 -318 275 -99 732 -263 1015 -365 283 -102 684 -246 890 -320 206 -74 553 -199 770 -277 405 -145 499 -179 820 -295 171 -62 188 -66 225 -57 22 6 863 258 1868 561 1005 303 1830 551 1832 551 3 0 4 2359 3 5241 l-3 5242 -840 269 c-462 147 -930 297 -1040 332 -110 35 -357 114 -550 176 -192 62 -417 134 -500 160 -82 26 -294 94 -469 150 -176 56 -324 103 -330 105 -6 2 -49 -12 -96 -30z"/>
                                                        </g>
                                                    </svg>
                                                    Open in Office web
                                                </MenuItem>
                                            :
                                                null
                                        }
                                    </>
                                :
                                    null
                            }
                            {
                                path.indexOf("/My Docs") !== -1 ?
                                    <>
                                        {
                                            sharedWith !== null && sharedWith.length > 0 ?
                                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('permission', data, collect)}>
                                                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.99956 2.99956C2.99956 2.70413 3.05775 2.41159 3.17081 2.13865C3.28386 1.86571 3.44957 1.6177 3.65847 1.4088C3.86738 1.1999 4.11538 1.03419 4.38832 0.921136C4.66126 0.80808 4.9538 0.74989 5.24923 0.74989C5.54466 0.74989 5.8372 0.80808 6.11014 0.921136C6.38309 1.03419 6.63109 1.1999 6.83999 1.4088C7.04889 1.6177 7.2146 1.86571 7.32766 2.13865C7.44071 2.41159 7.4989 2.70413 7.4989 2.99956C7.4989 3.29499 7.44071 3.58753 7.32766 3.86047C7.2146 4.13341 7.04889 4.38142 6.83999 4.59032C6.63109 4.79922 6.38309 4.96493 6.11014 5.07799C5.8372 5.19104 5.54466 5.24923 5.24923 5.24923C4.9538 5.24923 4.66126 5.19104 4.38832 5.07799C4.11538 4.96493 3.86738 4.79922 3.65847 4.59032C3.44957 4.38142 3.28386 4.13341 3.17081 3.86047C3.05775 3.58753 2.99956 3.29499 2.99956 2.99956ZM8.24879 2.99956C8.24879 2.20403 7.93277 1.44108 7.37024 0.878551C6.80771 0.316024 6.04476 0 5.24923 0C4.4537 0 3.69075 0.316024 3.12822 0.878551C2.56569 1.44108 2.24967 2.20403 2.24967 2.99956C2.24967 3.79509 2.56569 4.55804 3.12822 5.12057C3.69075 5.6831 4.4537 5.99912 5.24923 5.99912C6.04476 5.99912 6.80771 5.6831 7.37024 5.12057C7.93277 4.55804 8.24879 3.79509 8.24879 2.99956ZM0.74989 11.2484C0.778011 9.38066 2.30123 7.87385 4.17829 7.87385H6.32017C6.77479 7.87385 7.20832 7.9629 7.6067 8.12225C7.55514 7.83167 7.52468 7.5528 7.51062 7.29502C7.13333 7.18254 6.73495 7.12396 6.32251 7.12396H4.18064C1.87004 7.12396 0 8.99399 0 11.3022C0 11.6866 0.311673 11.9982 0.695992 11.9982H9.80247C9.84465 11.9982 9.88449 11.9936 9.92667 11.9865C9.61265 11.7592 9.33848 11.5108 9.09476 11.2484H0.74989ZM8.99868 7.06303L11.2484 6.16316V11.0468C9.52829 10.0977 9.03149 8.30269 9.00103 7.06303H8.99868ZM14.2456 7.06303C14.2151 8.30503 13.716 10.0977 11.9982 11.0468V6.16316L14.2456 7.06303ZM11.8319 5.28907C11.6983 5.23517 11.5483 5.23517 11.4147 5.28907L8.60265 6.4139C8.3894 6.50061 8.24879 6.70683 8.24879 6.93648C8.24879 8.41986 8.85573 10.8922 11.4077 11.9561C11.546 12.0146 11.703 12.0146 11.8412 11.9561C14.3909 10.8922 14.9978 8.41986 14.9978 6.93648C14.9978 6.70683 14.8572 6.50061 14.6439 6.4139L11.8319 5.28907Z" />
                                                    </svg>
                                                    Permissions
                                                </MenuItem>
                                            : currentFile !== null && currentFile.type === "folder" ?
                                                <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('advShare', data, collect)}>
                                                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.92857 3.42896C8.28482 3.42896 8.57143 3.14236 8.57143 2.78613V2.57185V2.1433V0.857644L12.8571 4.71461L8.57143 8.57158V7.28593V6.85737V6.6431C8.57143 6.28686 8.28482 6.00027 7.92857 6.00027H7.71429H5.14286C3.24911 6.00027 1.71429 7.53502 1.71429 9.42869C1.71429 9.651 1.73304 9.85992 1.76786 10.0501C1.28304 9.42065 0.857143 8.52069 0.857143 7.28593C0.857143 5.15656 2.58482 3.42896 4.71429 3.42896H7.71429H7.92857ZM7.71429 7.28593V7.71448V8.57158C7.71429 8.90907 7.9125 9.21709 8.22321 9.35369C8.53393 9.49029 8.89286 9.43404 9.14464 9.20905L13.4304 5.35208C13.6098 5.1887 13.7143 4.95835 13.7143 4.71461C13.7143 4.47087 13.6125 4.24053 13.4304 4.07714L9.14464 0.220173C8.89286 -0.00749573 8.53125 -0.0637432 8.22321 0.0755362C7.91518 0.214816 7.71429 0.520159 7.71429 0.857644V1.71475V2.1433V2.57185H6.85714H4.71429C2.11071 2.57185 0 4.68247 0 7.28593C0 10.3206 2.18304 11.6759 2.68393 11.9491C2.75089 11.9866 2.82589 12 2.90089 12C3.19286 12 3.42857 11.7616 3.42857 11.4723C3.42857 11.2715 3.31339 11.0866 3.16607 10.95C2.91429 10.7117 2.57143 10.2429 2.57143 9.42869C2.57143 8.00911 3.72321 6.85737 5.14286 6.85737H6.85714H7.71429V7.28593Z" />
                                                    </svg>
                                                    Share
                                                </MenuItem>
                                            :
                                                <></>
                                        }
                                    </>
                                :
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('share', data, collect)}>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.92857 3.42896C8.28482 3.42896 8.57143 3.14236 8.57143 2.78613V2.57185V2.1433V0.857644L12.8571 4.71461L8.57143 8.57158V7.28593V6.85737V6.6431C8.57143 6.28686 8.28482 6.00027 7.92857 6.00027H7.71429H5.14286C3.24911 6.00027 1.71429 7.53502 1.71429 9.42869C1.71429 9.651 1.73304 9.85992 1.76786 10.0501C1.28304 9.42065 0.857143 8.52069 0.857143 7.28593C0.857143 5.15656 2.58482 3.42896 4.71429 3.42896H7.71429H7.92857ZM7.71429 7.28593V7.71448V8.57158C7.71429 8.90907 7.9125 9.21709 8.22321 9.35369C8.53393 9.49029 8.89286 9.43404 9.14464 9.20905L13.4304 5.35208C13.6098 5.1887 13.7143 4.95835 13.7143 4.71461C13.7143 4.47087 13.6125 4.24053 13.4304 4.07714L9.14464 0.220173C8.89286 -0.00749573 8.53125 -0.0637432 8.22321 0.0755362C7.91518 0.214816 7.71429 0.520159 7.71429 0.857644V1.71475V2.1433V2.57185H6.85714H4.71429C2.11071 2.57185 0 4.68247 0 7.28593C0 10.3206 2.18304 11.6759 2.68393 11.9491C2.75089 11.9866 2.82589 12 2.90089 12C3.19286 12 3.42857 11.7616 3.42857 11.4723C3.42857 11.2715 3.31339 11.0866 3.16607 10.95C2.91429 10.7117 2.57143 10.2429 2.57143 9.42869C2.57143 8.00911 3.72321 6.85737 5.14286 6.85737H6.85714H7.71429V7.28593Z" />
                                        </svg>
                                        Share
                                    </MenuItem>
                            }
                            <div  className={"border-bottom"}></div>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('rename', data, collect)}>
                                <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 1.54688C2.48906 0.623437 1.50469 0 0.375 0H0V0.75H0.375C1.61719 0.75 2.625 1.75781 2.625 3V5.625H1.5H1.125V6.375H1.5H2.625V9C2.625 10.2422 1.61719 11.25 0.375 11.25H0V12H0.375C1.50469 12 2.48906 11.3766 3 10.4531C3.51094 11.3766 4.49531 12 5.625 12H6V11.25H5.625C4.38281 11.25 3.375 10.2422 3.375 9V6.375H4.5H4.875V5.625H4.5H3.375V3C3.375 1.75781 4.38281 0.75 5.625 0.75H6V0H5.625C4.49531 0 3.51094 0.623437 3 1.54688Z" />
                                </svg>
                                Rename
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('download', data, collect)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.51484 5.13984L5.51484 8.13984C5.36953 8.28516 5.13047 8.28516 4.98516 8.13984L1.98516 5.13984C1.83984 4.99453 1.83984 4.75547 1.98516 4.61016C2.13047 4.46484 2.36953 4.46484 2.51484 4.61016L4.875 6.97031V0.375C4.875 0.16875 5.04375 0 5.25 0C5.45625 0 5.625 0.16875 5.625 0.375V6.97031L7.98516 4.61016C8.13047 4.46484 8.36953 4.46484 8.51484 4.61016C8.66016 4.75547 8.66016 4.99453 8.51484 5.13984ZM0.75 7.875V10.125C0.75 10.7461 1.25391 11.25 1.875 11.25H8.625C9.24609 11.25 9.75 10.7461 9.75 10.125V7.875C9.75 7.66875 9.91875 7.5 10.125 7.5C10.3313 7.5 10.5 7.66875 10.5 7.875V10.125C10.5 11.1609 9.66094 12 8.625 12H1.875C0.839062 12 0 11.1609 0 10.125V7.875C0 7.66875 0.16875 7.5 0.375 7.5C0.58125 7.5 0.75 7.66875 0.75 7.875Z" />
                                </svg>
                                Download
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('copy', data, collect)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 8.25H5.25C4.83516 8.25 4.5 7.91484 4.5 7.5V1.5C4.5 1.08516 4.83516 0.75 5.25 0.75H7.78359C7.88203 0.75 7.97812 0.789844 8.04844 0.860156L9.63984 2.45156C9.71016 2.52187 9.75 2.61797 9.75 2.71641V7.5C9.75 7.91484 9.41484 8.25 9 8.25ZM10.1695 1.91953L8.58047 0.330469C8.36953 0.119531 8.08359 0 7.78594 0H5.25C4.42266 0 3.75 0.672656 3.75 1.5V7.5C3.75 8.32734 4.42266 9 5.25 9H9C9.82734 9 10.5 8.32734 10.5 7.5V2.71641C10.5 2.41875 10.3805 2.13281 10.1695 1.92188V1.91953ZM1.5 3C0.672656 3 0 3.67266 0 4.5V10.5C0 11.3273 0.672656 12 1.5 12H5.25C6.07734 12 6.75 11.3273 6.75 10.5V9.75H6V10.5C6 10.9148 5.66484 11.25 5.25 11.25H1.5C1.08516 11.25 0.75 10.9148 0.75 10.5V4.5C0.75 4.08516 1.08516 3.75 1.5 3.75H3V3H1.5Z" />
                                </svg>
                                Copy to
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('move', data, collect)}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.25 10.5C11.25 10.9148 10.9148 11.25 10.5 11.25H4.5C4.08516 11.25 3.75 10.9148 3.75 10.5V8.625H3V10.5C3 11.3273 3.67266 12 4.5 12H10.5C11.3273 12 12 11.3273 12 10.5V3.84141C12 3.54375 11.8805 3.25781 11.6695 3.04688L8.95547 0.330469C8.74453 0.119531 8.45859 0 8.16094 0H4.5C3.67266 0 3 0.672656 3 1.5V6H3.75V1.5C3.75 1.08516 4.08516 0.75 4.5 0.75H7.5V3.375C7.5 3.99609 8.00391 4.5 8.625 4.5H11.25V10.5ZM11.2383 3.75H8.625C8.41875 3.75 8.25 3.58125 8.25 3.375V0.761719C8.31563 0.778125 8.37656 0.810938 8.42344 0.860156L11.1398 3.57656C11.1891 3.62578 11.2219 3.68438 11.2383 3.75ZM6.63984 4.98516C6.49453 4.83984 6.25547 4.83984 6.11016 4.98516C5.96484 5.13047 5.96484 5.36953 6.11016 5.51484L7.72031 7.125H0.375C0.16875 7.125 0 7.29375 0 7.5C0 7.70625 0.16875 7.875 0.375 7.875H7.72031L6.11016 9.48516C5.96484 9.63047 5.96484 9.86953 6.11016 10.0148C6.25547 10.1602 6.49453 10.1602 6.63984 10.0148L8.88984 7.76484C9.03516 7.61953 9.03516 7.38047 8.88984 7.23516L6.63984 4.98516Z" />
                                </svg>
                                Move to
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('delete', data, collect)}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.49539 0.75H6.83542C6.97455 0.75 7.10357 0.815625 7.17946 0.925781L7.56652 1.5H3.76682L4.15387 0.925781C4.22723 0.815625 4.35878 0.75 4.49792 0.75H4.49539ZM8.52277 1.5L7.86756 0.529688C7.64494 0.199219 7.25536 0 6.83795 0H4.49539C4.07798 0 3.68839 0.199219 3.46577 0.529688L2.81057 1.5H1.62158H0.809524H0.404762C0.182143 1.5 0 1.66875 0 1.875C0 2.08125 0.182143 2.25 0.404762 2.25H0.867708L1.5128 10.6078C1.57098 11.393 2.27679 12 3.12679 12H8.20655C9.05655 12 9.75982 11.393 9.82054 10.6078L10.4656 2.25H10.9286C11.1512 2.25 11.3333 2.08125 11.3333 1.875C11.3333 1.66875 11.1512 1.5 10.9286 1.5H10.5238H9.71175H8.52277ZM9.6561 2.25L9.01354 10.5539C8.98318 10.9453 8.63155 11.25 8.20655 11.25H3.12679C2.70179 11.25 2.35015 10.9453 2.31979 10.5539L1.67976 2.25H9.65357H9.6561Z" />
                                </svg>
                                Delete
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('replace', data, collect)}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 3.09375V1.125C0.75 0.91875 0.58125 0.75 0.375 0.75C0.16875 0.75 0 0.91875 0 1.125V4.125C0 4.33125 0.16875 4.5 0.375 4.5H3.375C3.58125 4.5 3.75 4.33125 3.75 4.125C3.75 3.91875 3.58125 3.75 3.375 3.75H1.25625C2.09766 1.97578 3.90703 0.75 6 0.75C8.89922 0.75 11.25 3.10078 11.25 6C11.25 8.89922 8.89922 11.25 6 11.25C4.28203 11.25 2.75859 10.425 1.8 9.15C1.67578 8.98359 1.44141 8.95078 1.275 9.075C1.10859 9.19922 1.07578 9.43359 1.2 9.6C2.29453 11.0578 4.03594 12 6 12C9.31406 12 12 9.31406 12 6C12 2.68594 9.31406 0 6 0C3.74062 0 1.77422 1.24922 0.75 3.09375ZM6 3C5.79375 3 5.625 3.16875 5.625 3.375V6C5.625 6.09844 5.66484 6.19453 5.73516 6.26484L7.61016 8.13984C7.75547 8.28516 7.99453 8.28516 8.13984 8.13984C8.28516 7.99453 8.28516 7.75547 8.13984 7.61016L6.375 5.84531V3.375C6.375 3.16875 6.20625 3 6 3Z" />
                                </svg>
                                Version History
                            </MenuItem>
                            {
                                modificationAllowed ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('detail', data, collect)}>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.5 11.25H6.94219C7.17188 11.5266 7.43438 11.7727 7.72734 11.9836C7.65234 11.9953 7.57734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V4.65234C8.7375 4.72734 8.48672 4.82578 8.25 4.94766V4.49766H5.625C5.00391 4.49766 4.5 3.99375 4.5 3.37266V0.747656L1.5 0.75C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM12.75 8.625C12.75 7.92881 12.4734 7.26113 11.9812 6.76884C11.4889 6.27656 10.8212 6 10.125 6C9.42881 6 8.76113 6.27656 8.26884 6.76884C7.77656 7.26113 7.5 7.92881 7.5 8.625C7.5 9.32119 7.77656 9.98887 8.26884 10.4812C8.76113 10.9734 9.42881 11.25 10.125 11.25C10.8212 11.25 11.4889 10.9734 11.9812 10.4812C12.4734 9.98887 12.75 9.32119 12.75 8.625ZM6.75 8.625C6.75 7.72989 7.10558 6.87145 7.73851 6.23851C8.37145 5.60558 9.22989 5.25 10.125 5.25C11.0201 5.25 11.8785 5.60558 12.5115 6.23851C13.1444 6.87145 13.5 7.72989 13.5 8.625C13.5 9.52011 13.1444 10.3785 12.5115 11.0115C11.8785 11.6444 11.0201 12 10.125 12C9.22989 12 8.37145 11.6444 7.73851 11.0115C7.10558 10.3785 6.75 9.52011 6.75 8.625ZM10.125 7.875C9.97582 7.875 9.83274 7.81574 9.72725 7.71025C9.62176 7.60476 9.5625 7.46168 9.5625 7.3125C9.5625 7.16332 9.62176 7.02024 9.72725 6.91475C9.83274 6.80926 9.97582 6.75 10.125 6.75C10.2742 6.75 10.4173 6.80926 10.5227 6.91475C10.6282 7.02024 10.6875 7.16332 10.6875 7.3125C10.6875 7.46168 10.6282 7.60476 10.5227 7.71025C10.4173 7.81574 10.2742 7.875 10.125 7.875ZM9.375 10.125C9.375 9.91875 9.54375 9.75 9.75 9.75V9C9.54375 9 9.375 8.83125 9.375 8.625C9.375 8.41875 9.54375 8.25 9.75 8.25H10.125C10.3313 8.25 10.5 8.41875 10.5 8.625V9.75C10.7063 9.75 10.875 9.91875 10.875 10.125C10.875 10.3313 10.7063 10.5 10.5 10.5H10.125H9.75C9.54375 10.5 9.375 10.3313 9.375 10.125Z" />
                                        </svg>
                                        View Details
                                    </MenuItem>
                                :
                                    <></>
                            }
                            {
                                helper.isExtensionAllowed(user, 'docusign') && helper.isExtensionEnable(user, 'docusign') && helper.canSignDocument(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('sign', data, collect)}>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.5 11.25C7.91484 11.25 8.25 10.9148 8.25 10.5V10.2492L8.80781 10.1109C8.87344 10.0945 8.93906 10.0734 9 10.0477V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V4.77188L8.25 5.52188V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5ZM5.625 3.75H8.23828C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75ZM3.375 8.17969L3.14531 8.94844C3.00234 9.42422 2.56406 9.75 2.06719 9.75H1.875C1.66875 9.75 1.5 9.58125 1.5 9.375C1.5 9.16875 1.66875 9 1.875 9H2.06719C2.23359 9 2.37891 8.89219 2.42578 8.73281L2.775 7.57266C2.85469 7.30781 3.09844 7.125 3.375 7.125C3.65156 7.125 3.89531 7.30547 3.975 7.57266L4.27031 8.55938C4.43672 8.36484 4.68047 8.25234 4.93828 8.25234C5.27109 8.25234 5.57578 8.43984 5.72344 8.7375L5.85469 9.00234H6.83203L7.2 7.53516C7.24922 7.33828 7.35234 7.15781 7.49531 7.0125L11.0977 3.40781C11.5359 2.96953 12.2484 2.96953 12.6891 3.40781L13.0969 3.81563C13.5352 4.25391 13.5352 4.96641 13.0969 5.40703L9.49453 9.00703C9.34922 9.15234 9.16875 9.25313 8.97187 9.30234L7.21641 9.74063C7.16953 9.75234 7.12031 9.75469 7.07344 9.74766L5.625 9.75C5.48203 9.75 5.35313 9.67031 5.28984 9.54375L5.05313 9.07031C5.03203 9.02812 4.9875 9 4.93828 9C4.89844 9 4.86094 9.01875 4.83516 9.05156L4.42266 9.6C4.33828 9.7125 4.19531 9.76875 4.05703 9.74531C3.91875 9.72187 3.80391 9.61875 3.76406 9.48281L3.375 8.17969ZM12.1594 3.9375C12.0141 3.79219 11.775 3.79219 11.6297 3.9375L11.0484 4.51875L11.9859 5.45625L12.5672 4.875C12.7125 4.72969 12.7125 4.49062 12.5672 4.34531L12.1594 3.9375ZM8.02734 7.53984C7.97813 7.58906 7.94531 7.64766 7.92891 7.71328L7.64062 8.86172L8.78906 8.57344C8.85469 8.55703 8.91562 8.52188 8.9625 8.475L11.4539 5.98594L10.5164 5.04844L8.02734 7.53984Z" />
                                        </svg>
                                        Send For Signature
                                    </MenuItem>
                                :
                                    null
                            }
                            {
                                helper.isExtensionAllowed(user, 'adobesign') && helper.isExtensionEnable(user, 'adobesign') && helper.canSignDocument(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('adobesign', data, collect)}>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.5 11.25C7.91484 11.25 8.25 10.9148 8.25 10.5V10.2492L8.80781 10.1109C8.87344 10.0945 8.93906 10.0734 9 10.0477V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V4.77188L8.25 5.52188V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5ZM5.625 3.75H8.23828C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75ZM3.375 8.17969L3.14531 8.94844C3.00234 9.42422 2.56406 9.75 2.06719 9.75H1.875C1.66875 9.75 1.5 9.58125 1.5 9.375C1.5 9.16875 1.66875 9 1.875 9H2.06719C2.23359 9 2.37891 8.89219 2.42578 8.73281L2.775 7.57266C2.85469 7.30781 3.09844 7.125 3.375 7.125C3.65156 7.125 3.89531 7.30547 3.975 7.57266L4.27031 8.55938C4.43672 8.36484 4.68047 8.25234 4.93828 8.25234C5.27109 8.25234 5.57578 8.43984 5.72344 8.7375L5.85469 9.00234H6.83203L7.2 7.53516C7.24922 7.33828 7.35234 7.15781 7.49531 7.0125L11.0977 3.40781C11.5359 2.96953 12.2484 2.96953 12.6891 3.40781L13.0969 3.81563C13.5352 4.25391 13.5352 4.96641 13.0969 5.40703L9.49453 9.00703C9.34922 9.15234 9.16875 9.25313 8.97187 9.30234L7.21641 9.74063C7.16953 9.75234 7.12031 9.75469 7.07344 9.74766L5.625 9.75C5.48203 9.75 5.35313 9.67031 5.28984 9.54375L5.05313 9.07031C5.03203 9.02812 4.9875 9 4.93828 9C4.89844 9 4.86094 9.01875 4.83516 9.05156L4.42266 9.6C4.33828 9.7125 4.19531 9.76875 4.05703 9.74531C3.91875 9.72187 3.80391 9.61875 3.76406 9.48281L3.375 8.17969ZM12.1594 3.9375C12.0141 3.79219 11.775 3.79219 11.6297 3.9375L11.0484 4.51875L11.9859 5.45625L12.5672 4.875C12.7125 4.72969 12.7125 4.49062 12.5672 4.34531L12.1594 3.9375ZM8.02734 7.53984C7.97813 7.58906 7.94531 7.64766 7.92891 7.71328L7.64062 8.86172L8.78906 8.57344C8.85469 8.55703 8.91562 8.52188 8.9625 8.475L11.4539 5.98594L10.5164 5.04844L8.02734 7.53984Z" />
                                        </svg>
                                        Send For Adobe Signature
                                    </MenuItem>
                                :
                                    null
                            }
                        </ContextMenu>
                    : path.indexOf("/Email") !== -1 ?
                        <ContextMenu id="file_dropdown_menu" onShow={(e) => this.onContextMenuShow(e)}>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('download', data, collect)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.51484 5.13984L5.51484 8.13984C5.36953 8.28516 5.13047 8.28516 4.98516 8.13984L1.98516 5.13984C1.83984 4.99453 1.83984 4.75547 1.98516 4.61016C2.13047 4.46484 2.36953 4.46484 2.51484 4.61016L4.875 6.97031V0.375C4.875 0.16875 5.04375 0 5.25 0C5.45625 0 5.625 0.16875 5.625 0.375V6.97031L7.98516 4.61016C8.13047 4.46484 8.36953 4.46484 8.51484 4.61016C8.66016 4.75547 8.66016 4.99453 8.51484 5.13984ZM0.75 7.875V10.125C0.75 10.7461 1.25391 11.25 1.875 11.25H8.625C9.24609 11.25 9.75 10.7461 9.75 10.125V7.875C9.75 7.66875 9.91875 7.5 10.125 7.5C10.3313 7.5 10.5 7.66875 10.5 7.875V10.125C10.5 11.1609 9.66094 12 8.625 12H1.875C0.839062 12 0 11.1609 0 10.125V7.875C0 7.66875 0.16875 7.5 0.375 7.5C0.58125 7.5 0.75 7.66875 0.75 7.875Z" />
                                </svg>
                                Download
                            </MenuItem>
                            <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('delete', data, collect)}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.49539 0.75H6.83542C6.97455 0.75 7.10357 0.815625 7.17946 0.925781L7.56652 1.5H3.76682L4.15387 0.925781C4.22723 0.815625 4.35878 0.75 4.49792 0.75H4.49539ZM8.52277 1.5L7.86756 0.529688C7.64494 0.199219 7.25536 0 6.83795 0H4.49539C4.07798 0 3.68839 0.199219 3.46577 0.529688L2.81057 1.5H1.62158H0.809524H0.404762C0.182143 1.5 0 1.66875 0 1.875C0 2.08125 0.182143 2.25 0.404762 2.25H0.867708L1.5128 10.6078C1.57098 11.393 2.27679 12 3.12679 12H8.20655C9.05655 12 9.75982 11.393 9.82054 10.6078L10.4656 2.25H10.9286C11.1512 2.25 11.3333 2.08125 11.3333 1.875C11.3333 1.66875 11.1512 1.5 10.9286 1.5H10.5238H9.71175H8.52277ZM9.6561 2.25L9.01354 10.5539C8.98318 10.9453 8.63155 11.25 8.20655 11.25H3.12679C2.70179 11.25 2.35015 10.9453 2.31979 10.5539L1.67976 2.25H9.65357H9.6561Z" />
                                </svg>
                                Delete
                            </MenuItem>
                        </ContextMenu>
                    : path.includes("/GoogleDrive") ?
                        <ContextMenu id="file_dropdown_menu" onShow={(e) => this.onContextMenuShow(e)}>
                            <MenuItem data={{}} onClick={(e) => this.onCopyMyDocModal(true)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 8.25H5.25C4.83516 8.25 4.5 7.91484 4.5 7.5V1.5C4.5 1.08516 4.83516 0.75 5.25 0.75H7.78359C7.88203 0.75 7.97812 0.789844 8.04844 0.860156L9.63984 2.45156C9.71016 2.52187 9.75 2.61797 9.75 2.71641V7.5C9.75 7.91484 9.41484 8.25 9 8.25ZM10.1695 1.91953L8.58047 0.330469C8.36953 0.119531 8.08359 0 7.78594 0H5.25C4.42266 0 3.75 0.672656 3.75 1.5V7.5C3.75 8.32734 4.42266 9 5.25 9H9C9.82734 9 10.5 8.32734 10.5 7.5V2.71641C10.5 2.41875 10.3805 2.13281 10.1695 1.92188V1.91953ZM1.5 3C0.672656 3 0 3.67266 0 4.5V10.5C0 11.3273 0.672656 12 1.5 12H5.25C6.07734 12 6.75 11.3273 6.75 10.5V9.75H6V10.5C6 10.9148 5.66484 11.25 5.25 11.25H1.5C1.08516 11.25 0.75 10.9148 0.75 10.5V4.5C0.75 4.08516 1.08516 3.75 1.5 3.75H3V3H1.5Z" />
                                </svg>
                                Copy
                            </MenuItem>
                        </ContextMenu>
                    : path.includes("/OneDrive") || path.includes("/Sharepoint") ?
                        <ContextMenu id="file_dropdown_menu" onShow={(e) => this.onContextMenuShow(e)}>
                            {
                                modificationAllowed && helper.hasThumbnail(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('imagePreview', data, collect)}>
                                        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                        </svg>
                                        Preview
                                    </MenuItem>
                                :   
                                    <></>
                            }
                            {
                                modificationAllowed && helper.isPdfDocument(checkedFile) ?
                                    <MenuItem data={{}} onClick={(e, data, collect) => this.onContextMenuItemClick('pdfPreview', data, collect)}>
                                        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.625 7.5C5.625 7.10218 5.46696 6.72064 5.18566 6.43934C4.90436 6.15804 4.52282 6 4.125 6C3.72718 6 3.34564 6.15804 3.06434 6.43934C2.78304 6.72064 2.625 7.10218 2.625 7.5C2.625 7.89782 2.78304 8.27936 3.06434 8.56066C3.34564 8.84196 3.72718 9 4.125 9C4.52282 9 4.90436 8.84196 5.18566 8.56066C5.46696 8.27936 5.625 7.89782 5.625 7.5ZM5.42813 9.33516C5.06016 9.59531 4.61016 9.75 4.125 9.75C2.88281 9.75 1.875 8.74219 1.875 7.5C1.875 6.25781 2.88281 5.25 4.125 5.25C5.36719 5.25 6.375 6.25781 6.375 7.5C6.375 7.98516 6.22031 8.43516 5.96016 8.80313L7.01719 9.86016C7.1625 10.0055 7.1625 10.2445 7.01719 10.3898C6.87187 10.5352 6.63281 10.5352 6.4875 10.3898L5.43047 9.33281L5.42813 9.33516ZM8.25 10.5V4.5H5.625C5.00391 4.5 4.5 3.99609 4.5 3.375V0.75H1.5C1.08516 0.75 0.75 1.08516 0.75 1.5V10.5C0.75 10.9148 1.08516 11.25 1.5 11.25H7.5C7.91484 11.25 8.25 10.9148 8.25 10.5ZM8.23828 3.75C8.22188 3.68438 8.18906 3.62344 8.13984 3.57656L5.42344 0.860156C5.37422 0.810938 5.31563 0.778125 5.25 0.761719V3.375C5.25 3.58125 5.41875 3.75 5.625 3.75H8.23828ZM0 1.5C0 0.672656 0.672656 0 1.5 0H5.15859C5.45625 0 5.74219 0.119531 5.95312 0.330469L8.66953 3.04453C8.88047 3.25547 9 3.54141 9 3.83906V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5Z" />
                                        </svg>
                                        Preview
                                    </MenuItem>
                                :   
                                    <></>
                            }
                            <MenuItem data={{}} onClick={(e) => this.onCopyMyDocModal(true)}>
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 8.25H5.25C4.83516 8.25 4.5 7.91484 4.5 7.5V1.5C4.5 1.08516 4.83516 0.75 5.25 0.75H7.78359C7.88203 0.75 7.97812 0.789844 8.04844 0.860156L9.63984 2.45156C9.71016 2.52187 9.75 2.61797 9.75 2.71641V7.5C9.75 7.91484 9.41484 8.25 9 8.25ZM10.1695 1.91953L8.58047 0.330469C8.36953 0.119531 8.08359 0 7.78594 0H5.25C4.42266 0 3.75 0.672656 3.75 1.5V7.5C3.75 8.32734 4.42266 9 5.25 9H9C9.82734 9 10.5 8.32734 10.5 7.5V2.71641C10.5 2.41875 10.3805 2.13281 10.1695 1.92188V1.91953ZM1.5 3C0.672656 3 0 3.67266 0 4.5V10.5C0 11.3273 0.672656 12 1.5 12H5.25C6.07734 12 6.75 11.3273 6.75 10.5V9.75H6V10.5C6 10.9148 5.66484 11.25 5.25 11.25H1.5C1.08516 11.25 0.75 10.9148 0.75 10.5V4.5C0.75 4.08516 1.08516 3.75 1.5 3.75H3V3H1.5Z" />
                                </svg>
                                Copy
                            </MenuItem>
                        </ContextMenu>
                    :
                        <></>
                }
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                    {
                        officeFileModal === false ?
                            <link rel="shortcut icon" href="favicon.ico" />
                        :
                        null
                    }
                </Helmet>
                <form ref={this.editDocRef} target='_blank' method='GET' style={{display: 'none'}}>
                    {/* <input ref={this.editDocTokenRef} name="oauth-token" type="hidden" /> */}
                </form>
                {
                    docusignModal ?
                        <SignModal
                            open={docusignModal}
                            files={checkedFiles}
                            onClose={() => this.onSignDocument(false)}
                            store={this.store}
                            onDocusignConnect={(type) => this.onDocusignConnect(type)}
                            onSignSuccess={(data) => this.onDocusignSuccess(data)}
                        />
                    :
                        null
                }
                {
                    adobesignModal ?
                        <AdobeSignModal
                            open={adobesignModal}
                            files={checkedFiles}
                            onClose={() => this.onAdobeSignDocument(false)}
                            store={this.store}
                            onAdobesignConnect={(type, authState) => this.onAdobesignConnect(type, authState)}
                            onSignSuccess={(data) => this.onAdobesignSuccess(data)}
                        />
                    :
                        null
                }
                {
                    newEditAccountModal && (
                        <NewEditAccountModal
                            open={newEditAccountModal}
                            user={user}
                            onClose={(status) => this.onNewEditAccountModal(false)}
                            confirmationMessage="Confirm Default Destination Folder"
                            store={this.store}
                            history={this.history}
                            type={editAccountType}
                        />
                    )
                }
                {
                    sharepointAccountModal && (
                        <SharepointAccountModal
                            open={sharepointAccountModal}
                            user={user}
                            onClose={(status, submit) => this.onSharepointAccountModal(false, submit)}
                            store={this.store}
                            history={this.history}
                        />
                    )
                }
                {
                    upgradeModal && (
                        <ConfirmationModal 
                            open={upgradeModal} 
                            onClose={() => this.onUpgradeModalClose(false)} 
                            onSuccess={() => this.onUpgradeModalSuccess()}
                            confirmationMessage="Please upgrade to paid plan in order to use this feature."
                            cancelButtonText={"Cancel"}
                            successButtonText={"Upgrade Now"}
                        />
                    )
                }
                {
                    deleteFileModal ?
                        <DeleteFileModal
                            deleteNote={true}
                            confirm={true}
                            deletedFiles={checkedFiles}
                            open={deleteFileModal}
                            onClose={() => this.onModalClose(false)}
                            onSuccess={() => this.onModalSuccess()}
                            loading={saving}
                            errorMessage={errorMessage}
                        />
                    :
                        <></>
                }
                {
                    deleteSnackbarOpen ?
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            className={classes.snackbar}
                            open={deleteSnackbarOpen}
                            autoHideDuration={2000}
                            onClose={this.closeDeleteSnackbar}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">{deleteFilesCount > 1 ? 'Items' : 'Item'} Moved to Trash</span>}
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className={classes.close}
                                    onClick={this.closeDeleteSnackbar}
                                >
                                    <CloseIcon />
                                </IconButton>
                            ]}
                        />
                    :
                        <></>
                }
            </div>
        )
    }
}

UserHome.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(UserHome);